import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, Component, ContentChild, ViewChild, Pipe, InjectionToken, HostListener, HostBinding, Optional, signal, ChangeDetectionStrategy, Inject, ContentChildren } from '@angular/core';
import { CurrencyPipe, DatePipe, NgTemplateOutlet, NgClass } from '@angular/common';
import { getProperty } from 'dot-prop';
import * as i2 from '@angular/forms';
import { FormControl, FormRecord, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { isEmpty } from 'lodash';
import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/cdk/table';
import { CdkTableModule } from '@angular/cdk/table';
const _c0 = ["headerTmpl"];
const _c1 = ["footerTmpl"];
const _c2 = ["cellTmpl"];
function NgxCurrencyTableCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, item_r1, ctx_r1.currency), " ");
  }
}
function NgxDateTableCellComponent_ng_template_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "time");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx, ctx_r0.format), " ");
  }
}
function NgxDateTableCellComponent_ng_template_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.emptyLabel);
  }
}
function NgxDateTableCellComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxDateTableCellComponent_ng_template_0_Conditional_0_Conditional_0_Template, 3, 4, "time");
    i0.ɵɵpipe(1, "getProp");
    i0.ɵɵtemplate(2, NgxDateTableCellComponent_ng_template_0_Conditional_0_Conditional_2_Template, 2, 1, "i");
  }
  if (rf & 2) {
    let tmp_5_0;
    const row_r2 = i0.ɵɵnextContext().row;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_5_0 = i0.ɵɵpipeBind2(1, 1, row_r2, ctx_r0.rowKey)) ? 0 : 2, tmp_5_0);
  }
}
function NgxDateTableCellComponent_ng_template_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "time");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r0.itemKey ? item_r3[ctx_r0.itemKey] : item_r3, ctx_r0.format));
  }
}
function NgxDateTableCellComponent_ng_template_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.emptyLabel);
  }
}
function NgxDateTableCellComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxDateTableCellComponent_ng_template_0_Conditional_1_Conditional_0_Template, 3, 4, "time")(1, NgxDateTableCellComponent_ng_template_0_Conditional_1_Conditional_1_Template, 2, 1, "i");
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(item_r3 ? 0 : 1);
  }
}
function NgxDateTableCellComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxDateTableCellComponent_ng_template_0_Conditional_0_Template, 3, 4)(1, NgxDateTableCellComponent_ng_template_0_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.rowKey ? 0 : 1);
  }
}
const _c3 = ["detailRowTmpl"];
const _c4 = ["emptyTmpl"];
const _c5 = ["loadingTmpl"];
const _c6 = ["checkboxTmpl"];
const _c7 = ["radioTmpl"];
const _c8 = ["sortTmpl"];
const _c9 = ["openRowStateTmpl"];
const _c10 = () => [];
const _c11 = (a0, a1) => ({
  isLoading: a0,
  isEmpty: a1
});
const _c12 = a0 => ({
  $implicit: a0,
  row: undefined,
  index: undefined
});
const _c13 = (a0, a1, a2) => ({
  $implicit: a0,
  row: a1,
  index: a2
});
const _c14 = a0 => ({
  $implicit: a0
});
const _c15 = a0 => ["ngx-table-cell", "ngx-table-header-cell", a0];
const _c16 = (a0, a1) => ({
  currentSorting: a0,
  cell: a1
});
const _c17 = a0 => ["ngx-table-cell", "ngx-table-row-cell", a0];
const _c18 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  row: a1,
  index: a2,
  isRowOpen: a3
});
const _c19 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
const _c20 = (a0, a1) => ["ngx-table-row", a0, a1];
const _c21 = () => ["ngxTableDetailColumn"];
function NgxTableComponent_Conditional_2_th_1_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_Conditional_2_th_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_Conditional_2_th_1_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    const checkboxTmpl_r2 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", checkboxTmpl_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c12, ctx_r0.headerControl));
  }
}
function NgxTableComponent_Conditional_2_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13);
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_2_th_1_Conditional_1_Template, 1, 4, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-readonly", ctx_r0.headerControl.disabled);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selectableType === "checkbox" ? 1 : -1);
  }
}
function NgxTableComponent_Conditional_2_td_2_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_Conditional_2_td_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_Conditional_2_td_2_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const row_r4 = ctx_r2.$implicit;
    const index_r5 = ctx_r2.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const checkboxTmpl_r2 = i0.ɵɵreference(15);
    const radioButtonTmpl_r6 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.selectableType === "checkbox" ? checkboxTmpl_r2 : radioButtonTmpl_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c13, ctx, row_r4, index_r5));
  }
}
function NgxTableComponent_Conditional_2_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 15);
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_2_td_2_Conditional_1_Template, 1, 6, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_10_0;
    const row_r4 = ctx.$implicit;
    const index_r5 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngxTreeGridCell", 0)("ngxTreeGridCellRow", index_r5);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_10_0 = ctx_r0.selectableType === "radio" || ctx_r0.selectableType === "checkbox" && ctx_r0.rowsFormGroup.controls[ctx_r0.selectableKey ? row_r4[ctx_r0.selectableKey] : index_r5]) ? 1 : -1, tmp_10_0);
  }
}
function NgxTableComponent_Conditional_2_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 16);
  }
}
function NgxTableComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 5);
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_2_th_1_Template, 2, 2, "th", 10)(2, NgxTableComponent_Conditional_2_td_2_Template, 2, 3, "td", 11)(3, NgxTableComponent_Conditional_2_td_3_Template, 1, 0, "td", 12);
    i0.ɵɵelementContainerEnd();
  }
}
function NgxTableComponent_Conditional_3_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 19);
  }
}
function NgxTableComponent_Conditional_3_td_2_ng_template_1_Template(rf, ctx) {}
function NgxTableComponent_Conditional_3_td_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 20);
    i0.ɵɵlistener("click", function NgxTableComponent_Conditional_3_td_2_Template_td_click_0_listener() {
      const ctx_r7 = i0.ɵɵrestoreView(_r7);
      const row_r9 = ctx_r7.$implicit;
      const index_r10 = ctx_r7.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleRowClicked(row_r9, index_r10));
    });
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_3_td_2_ng_template_1_Template, 0, 0, "ng-template", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const index_r10 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const defaultOpenRowStateTmpl_r11 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngxTreeGridCell", ctx_r0.selectable ? ctx_r0.columns.length + 1 : ctx_r0.columns.length + 2)("ngxTreeGridCellRow", index_r10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.openRowStateTemplate || defaultOpenRowStateTmpl_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c14, ctx_r0.showDetailRow === "always" || ctx_r0.showDetailRow === "on-single-item" && (ctx_r0.data == null ? null : ctx_r0.data.length) === 1 || ctx_r0.openRows.has(index_r10)));
  }
}
function NgxTableComponent_Conditional_3_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 16);
  }
}
function NgxTableComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 6);
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_3_th_1_Template, 1, 0, "th", 17)(2, NgxTableComponent_Conditional_3_td_2_Template, 2, 6, "td", 18)(3, NgxTableComponent_Conditional_3_td_3_Template, 1, 0, "td", 12);
    i0.ɵɵelementContainerEnd();
  }
}
function NgxTableComponent_For_5_th_1_Conditional_2_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_For_5_th_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_For_5_th_1_Conditional_2_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 26);
  }
  if (rf & 2) {
    const column_r13 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tableCellTemplateRecord()[column_r13].headerTemplate);
  }
}
function NgxTableComponent_For_5_th_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const column_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵtextInterpolate1(" ", column_r13, " ");
  }
}
function NgxTableComponent_For_5_th_1_Conditional_2_Conditional_3_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_For_5_th_1_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_For_5_th_1_Conditional_2_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const sortCell_r14 = i0.ɵɵnextContext();
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sortTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, sortCell_r14.sortDirection ? sortCell_r14.sortDirection.toString() : null));
  }
}
function NgxTableComponent_For_5_th_1_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 27);
    i0.ɵɵpipe(1, "ngxTableSortIcon");
  }
  if (rf & 2) {
    const sortCell_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(1, 1, sortCell_r14.sortDirection), i0.ɵɵsanitizeHtml);
  }
}
function NgxTableComponent_For_5_th_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function NgxTableComponent_For_5_th_1_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const column_r13 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleSort(column_r13));
    });
    i0.ɵɵtemplate(1, NgxTableComponent_For_5_th_1_Conditional_2_Conditional_1_Template, 1, 1, null, 26)(2, NgxTableComponent_For_5_th_1_Conditional_2_Conditional_2_Template, 1, 1)(3, NgxTableComponent_For_5_th_1_Conditional_2_Conditional_3_Template, 1, 4, null, 14)(4, NgxTableComponent_For_5_th_1_Conditional_2_Conditional_4_Template, 2, 3, "i", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_18_0;
    const column_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(((tmp_18_0 = ctx_r0.tableCellTemplateRecord()[column_r13]) == null ? null : tmp_18_0.headerTemplate) ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.sortTemplate ? 3 : 4);
  }
}
function NgxTableComponent_For_5_th_1_Conditional_3_Conditional_0_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_For_5_th_1_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_For_5_th_1_Conditional_3_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 26);
  }
  if (rf & 2) {
    const column_r13 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tableCellTemplateRecord()[column_r13].headerTemplate);
  }
}
function NgxTableComponent_For_5_th_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const column_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵtextInterpolate1(" ", column_r13, " ");
  }
}
function NgxTableComponent_For_5_th_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_For_5_th_1_Conditional_3_Conditional_0_Template, 1, 1, null, 26)(1, NgxTableComponent_For_5_th_1_Conditional_3_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    let tmp_17_0;
    const column_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(((tmp_17_0 = ctx_r0.tableCellTemplateRecord()[column_r13]) == null ? null : tmp_17_0.headerTemplate) ? 0 : 1);
  }
}
function NgxTableComponent_For_5_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 23);
    i0.ɵɵpipe(1, "ngxAriaSort");
    i0.ɵɵtemplate(2, NgxTableComponent_For_5_th_1_Conditional_2_Template, 5, 2, "button", 24)(3, NgxTableComponent_For_5_th_1_Conditional_3_Template, 2, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    let tmp_18_0;
    let tmp_21_0;
    const column_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("ngx-table-sortable-cell", ctx_r0.sortableTableCellRecord()[column_r13]);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c15, ((tmp_17_0 = ctx_r0.tableCellTemplateRecord()[column_r13]) == null ? null : tmp_17_0.cellClass) || ""));
    i0.ɵɵattribute("data-cy", ((tmp_18_0 = ctx_r0.tableCypressRecord()[column_r13]) == null ? null : tmp_18_0.header) || "")("aria-sort", i0.ɵɵpipeBind1(1, 7, i0.ɵɵpureFunction2(11, _c16, ctx_r0.currentSortingEvent(), ctx_r0.sortableTableCellRecord()[column_r13])))("aria-readonly", !ctx_r0.sortableTableCellRecord()[column_r13]);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_21_0 = ctx_r0.sortableTableCellRecord()[column_r13]) ? 2 : 3, tmp_21_0);
  }
}
function NgxTableComponent_For_5_td_2_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_For_5_td_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_For_5_td_2_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    const row_r17 = ctx_r18.$implicit;
    const index_r18 = ctx_r18.dataIndex;
    const column_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tableCellTemplateRecord()[column_r13].cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c18, row_r17[column_r13], row_r17, index_r18, ctx_r0.showDetailRow === "always" || ctx_r0.showDetailRow === "on-single-item" && (ctx_r0.data == null ? null : ctx_r0.data.length) === 1 || ctx_r0.openRows.has(index_r18)));
  }
}
function NgxTableComponent_For_5_td_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r17 = i0.ɵɵnextContext().$implicit;
    const column_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", row_r17[column_r13], " ");
  }
}
function NgxTableComponent_For_5_td_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 28);
    i0.ɵɵlistener("click", function NgxTableComponent_For_5_td_2_Template_td_click_0_listener() {
      const ctx_r15 = i0.ɵɵrestoreView(_r15);
      const row_r17 = ctx_r15.$implicit;
      const index_r18 = ctx_r15.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleRowClicked(row_r17, index_r18));
    });
    i0.ɵɵtemplate(1, NgxTableComponent_For_5_td_2_Conditional_1_Template, 1, 7, null, 14)(2, NgxTableComponent_For_5_td_2_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_18_0;
    let tmp_21_0;
    let tmp_24_0;
    const index_r18 = ctx.dataIndex;
    const ctx_r19 = i0.ɵɵnextContext();
    const column_r13 = ctx_r19.$implicit;
    const ɵ$index_42_r21 = ctx_r19.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c17, ((tmp_18_0 = ctx_r0.tableCellTemplateRecord()[column_r13]) == null ? null : tmp_18_0.cellClass) || ""))("ngxTreeGridCell", ctx_r0.selectable ? ɵ$index_42_r21 + 1 : ɵ$index_42_r21)("ngxTreeGridCellRow", index_r18);
    i0.ɵɵattribute("data-cy", ((tmp_21_0 = ctx_r0.tableCypressRecord()[column_r13]) == null ? null : tmp_21_0.cell) || "")("role", ctx_r0.detailRowTemplate ? "gridcell" : "cell")("aria-readonly", !ctx_r0.editableTableCellRecord()[column_r13]);
    i0.ɵɵadvance();
    i0.ɵɵconditional(((tmp_24_0 = ctx_r0.tableCellTemplateRecord()[column_r13]) == null ? null : tmp_24_0.cellTemplate) ? 1 : 2);
  }
}
function NgxTableComponent_For_5_td_3_Conditional_1_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_For_5_td_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_For_5_td_3_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 26);
  }
  if (rf & 2) {
    const column_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tableCellTemplateRecord()[column_r13].footerTemplate);
  }
}
function NgxTableComponent_For_5_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 16);
    i0.ɵɵtemplate(1, NgxTableComponent_For_5_td_3_Conditional_1_Template, 1, 1, null, 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    let tmp_18_0;
    const column_r13 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-cy", ((tmp_17_0 = ctx_r0.tableCypressRecord()[column_r13]) == null ? null : tmp_17_0.footer) || "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(((tmp_18_0 = ctx_r0.tableCellTemplateRecord()[column_r13]) == null ? null : tmp_18_0.footerTemplate) ? 1 : -1);
  }
}
function NgxTableComponent_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 7);
    i0.ɵɵtemplate(1, NgxTableComponent_For_5_th_1_Template, 4, 14, "th", 21)(2, NgxTableComponent_For_5_td_2_Template, 3, 9, "td", 22)(3, NgxTableComponent_For_5_td_3_Template, 2, 2, "td", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r13 = ctx.$implicit;
    i0.ɵɵproperty("cdkColumnDef", column_r13);
  }
}
function NgxTableComponent_Conditional_6_td_1_ng_template_1_Template(rf, ctx) {}
function NgxTableComponent_Conditional_6_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 30);
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_6_td_1_ng_template_1_Template, 0, 0, "ng-template", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r22 = ctx.$implicit;
    const index_r23 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const detailRowTmpl_r24 = i0.ɵɵreference(13);
    i0.ɵɵattribute("colspan", ctx_r0.definedColumns().length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", detailRowTmpl_r24)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c19, row_r22, index_r23));
  }
}
function NgxTableComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 8);
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_6_td_1_Template, 2, 6, "td", 29);
    i0.ɵɵelementContainerEnd();
  }
}
function NgxTableComponent_Conditional_7_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 9);
  }
}
function NgxTableComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_Conditional_7_tr_0_Template, 1, 0, "tr", 31);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cdkHeaderRowDef", ctx_r0.definedColumns());
  }
}
function NgxTableComponent_Conditional_9_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 35);
    i0.ɵɵlistener("ngxTreeGridRowSelectRow", function NgxTableComponent_Conditional_9_tr_0_Template_tr_ngxTreeGridRowSelectRow_0_listener() {
      const rowIndex_r26 = i0.ɵɵrestoreView(_r25).dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.selectRow(rowIndex_r26));
    })("ngxTreeGridRowExpandRow", function NgxTableComponent_Conditional_9_tr_0_Template_tr_ngxTreeGridRowExpandRow_0_listener($event) {
      const rowIndex_r26 = i0.ɵɵrestoreView(_r25).dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleRowState(rowIndex_r26, $event ? "open" : "close"));
    })("keydown.enter", function NgxTableComponent_Conditional_9_tr_0_Template_tr_keydown_enter_0_listener() {
      const ctx_r26 = i0.ɵɵrestoreView(_r25);
      const row_r28 = ctx_r26.$implicit;
      const rowIndex_r26 = ctx_r26.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleRowClicked(row_r28, rowIndex_r26));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    const row_r28 = ctx.$implicit;
    const rowIndex_r26 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("ngx-table-row-odd", rowIndex_r26 % 2 !== 0)("ngx-table-row-even", rowIndex_r26 % 2 === 0)("ngx-table-row-selected", ctx_r0.showSelectedOpenRow && (ctx_r0.selectedRow === rowIndex_r26 || ctx_r0.showDetailRow === "on-single-item" && (ctx_r0.data == null ? null : ctx_r0.data.length) === 1));
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c20, ctx_r0.rowClass || "", row_r28[ctx_r0.highlightKey] ? "ngx-table-row-highlight" : ""))("ngxTreeGridRow", rowIndex_r26)("ngxTreeGridRowSelectable", ctx_r0.selectable)("ngxTreeGridRowExpanded", ctx_r0.openRows.has(rowIndex_r26));
    i0.ɵɵattribute("tabindex", ctx_r0.detailRowTemplate !== undefined || ctx_r0.selectable ? 0 : -1)("aria-setsize", ctx_r0.detailRowTemplate ? 1 : 0)("aria-selected", (tmp_17_0 = ctx_r0.rowsFormGroup.get(ctx_r0.selectableKey ? "" + ctx_r0.data[rowIndex_r26][ctx_r0.selectableKey] : "" + rowIndex_r26)) == null ? null : tmp_17_0.value);
  }
}
function NgxTableComponent_Conditional_9_Conditional_1_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 37);
  }
  if (rf & 2) {
    const index_r29 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("ngx-table-detail-row-open", ctx_r0.showDetailRow === "always" || ctx_r0.showDetailRow === "on-single-item" && (ctx_r0.data == null ? null : ctx_r0.data.length) === 1 || ctx_r0.openRows.has(index_r29));
  }
}
function NgxTableComponent_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_Conditional_9_Conditional_1_tr_0_Template, 1, 2, "tr", 36);
  }
  if (rf & 2) {
    i0.ɵɵproperty("cdkRowDefColumns", i0.ɵɵpureFunction0(1, _c21));
  }
}
function NgxTableComponent_Conditional_9_Conditional_2_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 34);
  }
}
function NgxTableComponent_Conditional_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_Conditional_9_Conditional_2_tr_0_Template, 1, 0, "tr", 38);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cdkFooterRowDef", ctx_r0.definedColumns());
  }
}
function NgxTableComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_Conditional_9_tr_0_Template, 1, 16, "tr", 32)(1, NgxTableComponent_Conditional_9_Conditional_1_Template, 1, 2, "tr", 33)(2, NgxTableComponent_Conditional_9_Conditional_2_Template, 1, 1, "tr", 34);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cdkRowDefColumns", ctx_r0.definedColumns());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.detailRowTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.hasFooterTemplates() ? 2 : -1);
  }
}
function NgxTableComponent_Conditional_10_ng_template_1_Template(rf, ctx) {}
function NgxTableComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_10_ng_template_1_Template, 0, 0, "ng-template", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.emptyTemplate);
  }
}
function NgxTableComponent_Conditional_11_ng_template_1_Template(rf, ctx) {}
function NgxTableComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NgxTableComponent_Conditional_11_ng_template_1_Template, 0, 0, "ng-template", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loadingTemplate);
  }
}
function NgxTableComponent_ng_template_12_Conditional_0_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_ng_template_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_ng_template_12_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext();
    const row_r31 = ctx_r29.$implicit;
    const index_r32 = ctx_r29.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.detailRowTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c19, row_r31, index_r32));
  }
}
function NgxTableComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_ng_template_12_Conditional_0_Template, 1, 5, null, 14);
  }
  if (rf & 2) {
    const index_r32 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.showDetailRow === "always" || ctx_r0.showDetailRow === "on-single-item" && (ctx_r0.data == null ? null : ctx_r0.data.length) === 1 || ctx_r0.openRows.has(index_r32) ? 0 : -1);
  }
}
function NgxTableComponent_ng_template_14_Conditional_0_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_ng_template_14_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_ng_template_14_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext();
    const control_r34 = ctx_r32.$implicit;
    const row_r35 = ctx_r32.row;
    const index_r36 = ctx_r32.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.checkboxTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c13, control_r34, row_r35, index_r36));
  }
}
function NgxTableComponent_ng_template_14_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 39);
  }
  if (rf & 2) {
    const control_r34 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("formControl", control_r34);
  }
}
function NgxTableComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_ng_template_14_Conditional_0_Template, 1, 6, null, 14)(1, NgxTableComponent_ng_template_14_Conditional_1_Template, 1, 1, "input", 39);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.checkboxTemplate ? 0 : 1);
  }
}
function NgxTableComponent_ng_template_16_Conditional_0_ng_template_0_Template(rf, ctx) {}
function NgxTableComponent_ng_template_16_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_ng_template_16_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext();
    const row_r38 = ctx_r36.row;
    const index_r39 = ctx_r36.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.radioTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c13, ctx_r0.radioControl, row_r38, index_r39));
  }
}
function NgxTableComponent_ng_template_16_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 40);
  }
  if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext();
    const row_r38 = ctx_r36.row;
    const index_r39 = ctx_r36.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", index_r39)("value", ctx_r0.selectableKey ? row_r38[ctx_r0.selectableKey] : index_r39)("formControl", ctx_r0.radioControl);
  }
}
function NgxTableComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxTableComponent_ng_template_16_Conditional_0_Template, 1, 6, null, 14)(1, NgxTableComponent_ng_template_16_Conditional_1_Template, 1, 3, "input", 40);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.radioTemplate ? 0 : 1);
  }
}
function NgxTableComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 41);
  }
  if (rf & 2) {
    const open_r40 = ctx.$implicit;
    i0.ɵɵproperty("innerHtml", open_r40 ? "\u25B2" : "\u25BC", i0.ɵɵsanitizeHtml);
  }
}
var NgxTableSortDirection;
(function (NgxTableSortDirection) {
  NgxTableSortDirection["ASCENDING"] = "ASCENDING";
  NgxTableSortDirection["DESCENDING"] = "DESCENDING";
})(NgxTableSortDirection || (NgxTableSortDirection = {}));
class NgxAbstractTableCellDirective {
  constructor() {
    /**
     * The current sortDirection of the cell
     */
    this.sortDirection = null;
    /**
     * Whether or not the cell is sortable
     */
    this.sortable = false;
    /**
     * Whether the content of a cell is editable. By default, this is set to false
     */
    this.editable = false;
    /**
     * Emits the sortable event if a column is sortable
     */
    this.sort = new EventEmitter();
  }
  /**
   * Handles the sorting click events
   */
  handleSort() {
    // Iben: Setup the sort direction
    let newSortDirection = NgxTableSortDirection.ASCENDING;
    // Iben: If a an existing sorting direction exists, we switch based on the ones we have
    if (this.sortDirection) {
      newSortDirection = this.sortDirection === NgxTableSortDirection.ASCENDING ? NgxTableSortDirection.DESCENDING : NgxTableSortDirection.ASCENDING;
    }
    // Iben: Set the internal sorting direction
    this.setSortDirection(newSortDirection);
    // Iben: Emit the sorting event
    this.sort.emit({
      direction: this.sortDirection,
      column: this.column
    });
  }
  /**
   * Resets the sort direction back to null
   */
  resetSortDirection() {
    this.sortDirection = null;
  }
  /**
   * Sets the sorting direction based on the provided direction
   *
   * @param direction - The provided direction
   */
  setSortDirection(direction) {
    this.sortDirection = direction;
  }
  static {
    this.ɵfac = function NgxAbstractTableCellDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxAbstractTableCellDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxAbstractTableCellDirective,
      selectors: [["ngx-abstract-table-cell"]],
      inputs: {
        column: "column",
        sortable: "sortable",
        cypressDataTags: "cypressDataTags",
        editable: "editable"
      },
      outputs: {
        sort: "sort"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxAbstractTableCellDirective, [{
    type: Directive,
    args: [{
      selector: 'ngx-abstract-table-cell',
      standalone: true
    }]
  }], null, {
    column: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    sortable: [{
      type: Input
    }],
    cypressDataTags: [{
      type: Input
    }],
    editable: [{
      type: Input
    }],
    sort: [{
      type: Output
    }]
  });
})();
class NgxCurrencyTableCellComponent extends NgxAbstractTableCellDirective {
  constructor() {
    super(...arguments);
    /**
     * The [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) format of the provided amount, by default `EUR`
     */
    this.currency = 'EUR';
    /**
     * A generic class to indicate that this is a currency cell
     */
    this.cellClass = 'ngx-currency-table-cell';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵNgxCurrencyTableCellComponent_BaseFactory;
      return function NgxCurrencyTableCellComponent_Factory(__ngFactoryType__) {
        return (ɵNgxCurrencyTableCellComponent_BaseFactory || (ɵNgxCurrencyTableCellComponent_BaseFactory = i0.ɵɵgetInheritedFactory(NgxCurrencyTableCellComponent)))(__ngFactoryType__ || NgxCurrencyTableCellComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgxCurrencyTableCellComponent,
      selectors: [["ngx-currency-table-cell"]],
      contentQueries: function NgxCurrencyTableCellComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 5);
          i0.ɵɵcontentQuery(dirIndex, _c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        }
      },
      viewQuery: function NgxCurrencyTableCellComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
        }
      },
      inputs: {
        currency: "currency"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NgxAbstractTableCellDirective,
        useExisting: NgxCurrencyTableCellComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["cellTmpl", ""]],
      template: function NgxCurrencyTableCellComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NgxCurrencyTableCellComponent_ng_template_0_Template, 2, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
      },
      dependencies: [CurrencyPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxCurrencyTableCellComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-currency-table-cell',
      providers: [{
        provide: NgxAbstractTableCellDirective,
        useExisting: NgxCurrencyTableCellComponent
      }],
      template: `
		<ng-template #cellTmpl let-item>
			{{ item | currency : currency }}
		</ng-template>
	`,
      imports: [CurrencyPipe]
    }]
  }], null, {
    currency: [{
      type: Input
    }],
    headerTemplate: [{
      type: ContentChild,
      args: ['headerTmpl', {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: ['footerTmpl', {
        static: false
      }]
    }],
    cellTemplate: [{
      type: ViewChild,
      args: ['cellTmpl', {
        static: true
      }]
    }]
  });
})();

/**
 * This pipe returns a value based on a provided path
 *
 * @export
 * @class NgxTableGetPipe
 * @implements {PipeTransform}
 */
class NgxTableGetPipe {
  transform(value, path) {
    // Iben: Check if the value is not an object and return an empty string so the frontend doesn't break and warn the user
    if (typeof value !== 'object' || Array.isArray(value) || value === null) {
      console.warn('NgxTableGetPipe encountered a value that was not an object and returned an empty string instead.');
      return '';
    }
    // Iben: If no path was provided, we return the value and warn the user
    if (!path) {
      console.warn('NgxTableGetPipe did not receive a path to a property and returned an empty string instead.');
      return value;
    }
    // Iben: Return the property using dot-prop
    return getProperty(value, path);
  }
  static {
    this.ɵfac = function NgxTableGetPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTableGetPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "getProp",
      type: NgxTableGetPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTableGetPipe, [{
    type: Pipe,
    args: [{
      name: 'getProp',
      standalone: true
    }]
  }], null, null);
})();
class NgxDateTableCellComponent extends NgxAbstractTableCellDirective {
  constructor() {
    super(...arguments);
    /**
     * The format of the provided date, by default `dd/MM/yyyy`
     */
    this.format = 'dd/MM/yyyy';
    /**
     * The label to display when date is invalid or empty
     */
    this.emptyLabel = 'Empty date';
    /**
     * A generic class to indicate that this is a date cell
     */
    this.cellClass = 'ngx-date-table-cell';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵNgxDateTableCellComponent_BaseFactory;
      return function NgxDateTableCellComponent_Factory(__ngFactoryType__) {
        return (ɵNgxDateTableCellComponent_BaseFactory || (ɵNgxDateTableCellComponent_BaseFactory = i0.ɵɵgetInheritedFactory(NgxDateTableCellComponent)))(__ngFactoryType__ || NgxDateTableCellComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgxDateTableCellComponent,
      selectors: [["ngx-date-table-cell"]],
      contentQueries: function NgxDateTableCellComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 5);
          i0.ɵɵcontentQuery(dirIndex, _c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        }
      },
      viewQuery: function NgxDateTableCellComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
        }
      },
      inputs: {
        format: "format",
        emptyLabel: "emptyLabel",
        itemKey: "itemKey",
        rowKey: "rowKey"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NgxAbstractTableCellDirective,
        useExisting: NgxDateTableCellComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 0,
      consts: [["cellTmpl", ""]],
      template: function NgxDateTableCellComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NgxDateTableCellComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
      },
      dependencies: [DatePipe, NgxTableGetPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxDateTableCellComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-date-table-cell',
      providers: [{
        provide: NgxAbstractTableCellDirective,
        useExisting: NgxDateTableCellComponent
      }],
      template: `
		<ng-template #cellTmpl let-item let-row="row">
			@if (rowKey) { @if (row | getProp : rowKey; as rowItem) {
			<time>
				{{ rowItem | date : format }}
			</time>
			} @else {
			<i>{{ emptyLabel }}</i>
			} } @else { @if (item) {
			<time>{{ (itemKey ? item[itemKey] : item) | date : format }}</time>
			} @else {
			<i>{{ emptyLabel }}</i>
			} }
		</ng-template>
	`,
      imports: [DatePipe, NgxTableGetPipe]
    }]
  }], null, {
    format: [{
      type: Input
    }],
    emptyLabel: [{
      type: Input
    }],
    itemKey: [{
      type: Input
    }],
    rowKey: [{
      type: Input
    }],
    headerTemplate: [{
      type: ContentChild,
      args: ['headerTmpl', {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: ['footerTmpl', {
        static: false
      }]
    }],
    cellTemplate: [{
      type: ViewChild,
      args: ['cellTmpl', {
        static: true
      }]
    }]
  });
})();
class NgxTableCellDirective extends NgxAbstractTableCellDirective {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵNgxTableCellDirective_BaseFactory;
      return function NgxTableCellDirective_Factory(__ngFactoryType__) {
        return (ɵNgxTableCellDirective_BaseFactory || (ɵNgxTableCellDirective_BaseFactory = i0.ɵɵgetInheritedFactory(NgxTableCellDirective)))(__ngFactoryType__ || NgxTableCellDirective);
      };
    })();
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxTableCellDirective,
      selectors: [["ngx-table-cell"]],
      contentQueries: function NgxTableCellDirective_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 5);
          i0.ɵɵcontentQuery(dirIndex, _c2, 5);
          i0.ɵɵcontentQuery(dirIndex, _c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        }
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NgxAbstractTableCellDirective,
        useExisting: NgxTableCellDirective
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTableCellDirective, [{
    type: Directive,
    args: [{
      selector: 'ngx-table-cell',
      providers: [{
        provide: NgxAbstractTableCellDirective,
        useExisting: NgxTableCellDirective
      }],
      standalone: true
    }]
  }], null, {
    headerTemplate: [{
      type: ContentChild,
      args: ['headerTmpl', {
        static: false
      }]
    }],
    cellTemplate: [{
      type: ContentChild,
      args: ['cellTmpl', {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: ['footerTmpl', {
        static: false
      }]
    }]
  });
})();
const Cells = [NgxAbstractTableCellDirective, NgxTableCellDirective, NgxCurrencyTableCellComponent, NgxDateTableCellComponent];
const NgxTableConfigToken = new InjectionToken('NgxTableConfig');

/**
 * Generates a NgxTable form based on a provided selectable key. If no key is provided, the form is based on the index instead
 *
 * @param form - The form provided by the table
 * @param data - The data provided by the table
 * @param selectableKey - An optional key that will be used to fetch the keys of the controls
 */
const generateNgxTableForm = (form, data, selectableKey) => {
  // Iben: Early exit if the data is null or if no items were provided
  if (!data || data.length === 0) {
    return;
  }
  // Iben: If no selectable key was provided, we build a form based on the index
  if (!selectableKey) {
    return buildNgxTableForm(form, 'ngxTableIndex', data);
  }
  // Iben: If a selectable key was provided, we build a form based on the key
  return buildNgxTableForm(form, selectableKey, data);
};
/**
 * Builds the NgxTable form
 *
 * @param key - A key to determine whether we need to build the form based on the index or an actual key
 * @param data - The data provided by the table
 */
const buildNgxTableForm = (form, key, data) => {
  // Iben: Check if the selectableKey is unique, otherwise the form cannot be set correctly
  if (key !== 'ngxTableIndex') {
    const keys = new Set([...data].map(item => item[key]));
    if (keys.size !== data.length) {
      console.error('NgxTableComponent encountered a non unique selectableKey and can therefor not generate a FormGroup. Please provide a key with unique values.');
      return;
    }
  }
  // Iben: Add a new control based on the index or on the provided key
  data.forEach((item, index) => {
    form.addControl(key === 'ngxTableIndex' ? `${index}` : item[key], new FormControl());
  });
};

/**
 * Resets the NgxTable form if new data is provided, so new controls can be added to the form
 *
 * @param currentForm - The form we wish to mutate
 * @param data - The provided data in the table
 * @param selectableKey - Optional selectable key
 * @param resetFormOnNewData - Whether we wish to reset the form when new data was provided
 */
const resetNgxTableForm = (currentForm, data, selectableKey, resetFormOnNewData) => {
  // Iben: If no selectableKey was provided but resetFormOnNewData is false, we throw an error. This is because then the form is index based, and it cannot be reset
  if (!resetFormOnNewData && !selectableKey) {
    console.error('NgxTableComponent cannot keep the current form data if no selectableKey was provided, as the keys of the FormGroup are index based. Provide a selectableKey in order for the table to correctly function.');
    return;
  }
  // Iben: If no selectableKey was passed, we assume that we're in the index based form and we can remove all current controls
  if (!selectableKey) {
    // Iben: Loop over the current form and remove all controls
    Object.keys(currentForm.controls || []).forEach(control => {
      currentForm.removeControl(control, {
        emitEvent: false
      });
    });
    // Iben: Loop over data and create the new controls
    data.forEach((_, index) => {
      currentForm.addControl(`${index}`, new FormControl(), {
        emitEvent: false
      });
    });
    return;
  }
  // Iben: If we can reset the form we remove all controls of the form and add new
  if (resetFormOnNewData) {
    // Iben: Loop over the current form and remove all controls
    Object.keys(currentForm.controls || []).forEach(control => {
      currentForm.removeControl(control, {
        emitEvent: false
      });
    });
    // Iben: Loop over data and create the new controls
    data.forEach(item => {
      currentForm.addControl(item[selectableKey], new FormControl(), {
        emitEvent: false
      });
    });
    return;
  }
  // Iben If we cannot reset the form, we add new controls for each new data entry point
  // Iben:We start by grabbing all the current keys so we can see which ones need to be added
  const keys = new Set(Object.keys(currentForm.controls) || []);
  // Iben: Add new controls for the keys that do not exist yet
  [...data].forEach(item => {
    if (!keys.has(item[selectableKey])) {
      currentForm.addControl(item[selectableKey], new FormControl(), {
        emitEvent: false
      });
    }
  });
};

/**
 * Handles the writeValue value of an NgxTableComponent form
 *
 * @param value - The value we wish to convert
 * @param selectableKey - An optional key that is used to fetch the value
 */
const writeNgxTableValue = (value, selectableKey) => {
  // Iben: Early exit if the value is empty or not an array
  if (!Array.isArray(value) || value.length === 0) {
    return {};
  }
  // Iben: Create group value to patch
  return [...value].reduce((previousValue, selectedValue, index) => {
    // Iben: If a selectableKey is provided, we use the value as the key, otherwise we use the index
    const key = selectableKey ? selectedValue : index;
    return {
      ...previousValue,
      [key]: true
    };
  }, {});
};
/**
 * Get for every control in the group a record with the value `true`.
 *
 * @param data The formGroup whose controls will be used.
 * @returns A record with the key of the controls as key with the value `true`.
 */
const handleNgxTableHeaderValueChanges = data => {
  return Object.keys(data.controls || []).reduce((previousValues, currentValue) => ({
    ...previousValues,
    [currentValue]: true
  }), {});
};
/**
 * Handles the value changes of a NgxTableComponent form
 *
 * @param value - The value of the form
 */
const handleNgxTableValueChanges = value => {
  const result = [];
  // Iben: Foreach over the entries as a map and a filter would mean two loops instead of one
  Object.entries(value || {}).forEach(([key, isSelected]) => {
    if (isSelected) {
      result.push(key);
    }
  });
  return result;
};

/**
 * This pipe returns whether we want to show the header
 *
 * @export
 * @class NgxTableShowHeaderPipe
 * @implements {PipeTransform}
 */
class NgxTableShowHeaderPipe {
  transform(value, hideHeaderRowWhen) {
    // Iben: If we never want to hide the header row, we return true
    if (hideHeaderRowWhen === 'never') {
      return true;
    }
    // Iben: Check if the value is not an object and return an empty string so the frontend doesn't break and warn the user
    if (typeof value !== 'object' || !value) {
      console.warn('NgxTableShowHeaderPipe encountered a value that was not an object and showed the header.');
      return true;
    }
    // Iben: Add to set for better performance
    const options = new Set(hideHeaderRowWhen);
    // Iben: Check which cases need the header to be hidden, and then flip it
    return !(options.has('when-empty') && value.isEmpty || options.has('when-loading') && value.isLoading);
  }
  static {
    this.ɵfac = function NgxTableShowHeaderPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTableShowHeaderPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "ngxTableShowHeader",
      type: NgxTableShowHeaderPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTableShowHeaderPipe, [{
    type: Pipe,
    args: [{
      name: 'ngxTableShowHeader',
      standalone: true
    }]
  }], null, null);
})();
class NgxTableSortIconPipe {
  /**
   * Returns a icon based on the provided sort direction
   *
   * @param direction - The provided sort direction
   */
  transform(direction) {
    if (!direction) {
      return '&equiv;';
    }
    return direction === NgxTableSortDirection.ASCENDING ? '&uArr;' : '&dArr;';
  }
  static {
    this.ɵfac = function NgxTableSortIconPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTableSortIconPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "ngxTableSortIcon",
      type: NgxTableSortIconPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTableSortIconPipe, [{
    type: Pipe,
    args: [{
      name: 'ngxTableSortIcon',
      standalone: true
    }]
  }], null, null);
})();
class NgxTableHasObserversPipe {
  /**
   * Returns true in case an observer was set to an EventEmitter
   *
   * @param output - The provided EventEmitter
   */
  transform(output) {
    return output && output.observers.length > 0;
  }
  static {
    this.ɵfac = function NgxTableHasObserversPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTableHasObserversPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "ngxTableHasObservers",
      type: NgxTableHasObserversPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTableHasObserversPipe, [{
    type: Pipe,
    args: [{
      name: 'ngxTableHasObservers',
      standalone: true
    }]
  }], null, null);
})();
class NgxAriaSortPipe {
  transform(value) {
    const {
      cell
    } = value;
    if (!cell || !cell.sortDirection) {
      return 'none';
    }
    return cell.sortDirection.toLocaleLowerCase();
  }
  static {
    this.ɵfac = function NgxAriaSortPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxAriaSortPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "ngxAriaSort",
      type: NgxAriaSortPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxAriaSortPipe, [{
    type: Pipe,
    args: [{
      name: 'ngxAriaSort',
      standalone: true
    }]
  }], null, null);
})();
const Pipes = [NgxTableHasObserversPipe, NgxTableSortIconPipe, NgxTableGetPipe, NgxTableShowHeaderPipe, NgxAriaSortPipe];

/**
 * An abstract directive used as a base to handle focussed base actions
 */
class NgxHasFocusDirective {
  constructor() {
    /**
     * Whether the current element is focussed
     */
    this.hasFocus = false;
  }
  /**
   * Set the hasFocus flag
   */
  setFocus() {
    this.hasFocus = true;
  }
  /**
   * Remove the hasFocus flag
   */
  removeFocus() {
    this.hasFocus = false;
  }
  /**
   * Execute an action when the element has focussed
   *
   * @param action - The provided action
   */
  handleWhenFocussed(action) {
    if (this.hasFocus) {
      action();
    }
  }
  static {
    this.ɵfac = function NgxHasFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxHasFocusDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxHasFocusDirective,
      hostBindings: function NgxHasFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function NgxHasFocusDirective_focus_HostBindingHandler() {
            return ctx.setFocus();
          })("blur", function NgxHasFocusDirective_blur_HostBindingHandler() {
            return ctx.removeFocus();
          });
        }
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxHasFocusDirective, [{
    type: Directive,
    args: [{
      standalone: true
    }]
  }], null, {
    setFocus: [{
      type: HostListener,
      args: ['focus']
    }],
    removeFocus: [{
      type: HostListener,
      args: ['blur']
    }]
  });
})();

/**
 * An overarching directive to handle navigation according to the WCAG treegrid pattern
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/treegrid/
 */
class NgxTreeGridDirective {
  constructor() {
    /**
     * An array of all rows in the treegrid
     */
    this.rows = [];
    this.role = 'table';
  }
  /**
   * Registers a row to the rows array
   *
   * @param row - The provided row
   */
  registerRow(row) {
    this.rows.push(row);
  }
  /**
   * Removes a registered row from the grid
   *
   * @param index - The index of the provided row
   */
  removeRow(index) {
    this.rows = this.rows.slice(0, index).concat(this.rows.slice(index + 1));
  }
  /**
   * Returns a row from the grid
   *
   * @param index - The index of the row
   */
  getRow(index) {
    // Iben: Early exit if the row is not found
    if (!this.ngxTreeGrid) {
      return null;
    }
    // Iben: Return the row
    return this.rows[index];
  }
  /**
   * Returns the first row of the grid
   */
  getFirstRow() {
    return this.getRow(0);
  }
  /**
   * Returns the last row of the grid
   */
  getLastRow() {
    return this.getRow(this.rows.length - 1);
  }
  /**
   * Moves the row focus to either the top or the bottom row of the grid
   *
   * @param direction - Whether we want to go to the top or the bottom of the grid
   */
  moveTo(direction) {
    this.rows[direction === 'top' ? 0 : this.rows.length - 1]?.focus();
  }
  /**
   * Registers a a cell to a row of the grid
   *
   * @param cell - The provided cell
   */
  registerCell(index, cell) {
    this.getRow(index)?.registerCell(cell);
  }
  ngOnChanges() {
    // Iben: Set the role based on the tree grid
    this.role = this.ngxTreeGrid ? 'treegrid' : 'table';
  }
  static {
    this.ɵfac = function NgxTreeGridDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTreeGridDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxTreeGridDirective,
      selectors: [["", "ngxTreeGrid", ""]],
      hostVars: 1,
      hostBindings: function NgxTreeGridDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role);
        }
      },
      inputs: {
        ngxTreeGrid: "ngxTreeGrid",
        ngxTreeGridExpandable: "ngxTreeGridExpandable"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTreeGridDirective, [{
    type: Directive,
    args: [{
      selector: '[ngxTreeGrid]',
      standalone: true
    }]
  }], null, {
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    ngxTreeGrid: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    ngxTreeGridExpandable: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();

/**
 * A row directive to handle navigation according to the WCAG treegrid pattern
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/treegrid/
 */
class NgxTreeGridRowDirective extends NgxHasFocusDirective {
  /**
   * Sets focus on to the previous row
   */
  moveUp() {
    this.handleWhenFocussed(() => {
      this.parent.getRow(this.ngxTreeGridRow - 1)?.focus();
    });
  }
  /**
   * Sets focus to the next row
   */
  moveDown() {
    this.handleWhenFocussed(() => {
      this.parent.getRow(this.ngxTreeGridRow + 1)?.focus();
    });
  }
  /**
   * Sets the focus on the first cell in the row or closes the row when expanded
   */
  arrowRight() {
    this.handleWhenFocussed(() => {
      // Iben: Only when the row is not expanded we can move to the next cell, as by WCAG design
      if (this.parent.ngxTreeGridExpandable && this.ngxTreeGridRowExpanded) {
        this.ngxTreeGridRowExpandRow.emit(false);
        return;
      }
      // Iben: Focus on the first cell
      this.cells[0]?.focus();
    });
  }
  /**
   * Expand the row when closed
   */
  arrowLeft() {
    this.handleWhenFocussed(() => {
      this.ngxTreeGridRowExpandRow.emit(true);
    });
  }
  /**
   * Sets focus on the first row of the grid
   */
  moveToTopPageUp() {
    this.moveToTop();
  }
  /**
   * Sets focus on the first row of the grid
   */
  moveToTopHome() {
    this.moveToTop();
  }
  /**
   * Sets focus on the first row of the grid
   */
  moveToTopControlHome() {
    this.moveToTop();
  }
  /**
   * Sets focus on the last row of the grid
   */
  moveToBottomPageDown() {
    this.moveToBottom();
  }
  /**
   * Sets focus on the last row of the grid
   */
  moveToBottomEnd() {
    this.moveToBottom();
  }
  /**
   * Sets focus on the last row of the grid
   */
  moveToBottomControlEnd() {
    this.moveToBottom();
  }
  /**
   * Emits a select event to select a row
   */
  selectRowShift() {
    this.handleWhenFocussed(() => {
      this.selectRow();
    });
  }
  /**
   * Emits a select event to select a row
   */
  selectRowControl() {
    this.handleWhenFocussed(() => {
      this.selectRow();
    });
  }
  /**
   * Emits a select event to select a row below the current row and move focus to that row
   */
  selectNextRow() {
    this.handleWhenFocussed(() => {
      this.parent.getRow(this.ngxTreeGridRow + 1)?.selectRow();
      this.parent.getRow(this.ngxTreeGridRow + 1)?.focus();
    });
  }
  /**
   * Emits a select event to select a row above the current row and move focus to that row
   */
  selectPreviousRow() {
    this.handleWhenFocussed(() => {
      this.parent.getRow(this.ngxTreeGridRow - 1)?.selectRow();
      this.parent.getRow(this.ngxTreeGridRow - 1)?.focus();
    });
  }
  constructor(parent, elementRef) {
    super();
    this.parent = parent;
    this.elementRef = elementRef;
    /**
     * An array of all cells in the row
     */
    this.cells = [];
    /**
     * Marks the row as expanded
     */
    this.ngxTreeGridRowExpanded = false;
    /**
     * Whether the row is selectable
     */
    this.ngxTreeGridRowSelectable = false;
    /**
     * Emits a select row event
     */
    this.ngxTreeGridRowSelectRow = new EventEmitter();
    /**
     * Emits an expand row event
     */
    this.ngxTreeGridRowExpandRow = new EventEmitter();
    this.parent.registerRow(this);
  }
  /**
   * Registers a cell to the row
   *
   * @param  cell - The provided cell
   */
  registerCell(cell) {
    this.cells.push(cell);
  }
  /**
   * Focus on the row
   */
  focus() {
    this.elementRef.nativeElement.focus();
  }
  /**
   * Get a cell from either the current row, or one of the other rows in the grid
   *
   * @param cell - The cell we wish to target
   * @param row - The row we wish to target
   */
  getCell(cell, row) {
    // Iben: Get the index of the cell
    const index = typeof cell === 'string' ? cell === 'first' ? 0 : this.cells.length - 1 : cell;
    // Iben: If the cell is in the current row, we return the cell
    if (row === 'current') {
      return this.cells[index];
    }
    // Iben: If the row is either the above or below one, we get the cell from those rows
    if (row === 'above' || row === 'below') {
      return this.parent.getRow(row === 'below' ? this.ngxTreeGridRow + 1 : this.ngxTreeGridRow - 1)?.getCell(index, 'current');
    }
    // Iben: If the row is the first or last, we get those rows
    return row === 'first' ? this.parent.getFirstRow()?.getCell(index, 'current') : this.parent.getLastRow()?.getCell(index, 'current');
  }
  /**
   * Emit the row event only if the row is selectable
   */
  selectRow() {
    if (this.ngxTreeGridRowSelectable) {
      this.ngxTreeGridRowSelectRow.emit();
    }
  }
  /**
   * Move to the top of the grid
   */
  moveToTop() {
    this.handleWhenFocussed(() => {
      this.parent.moveTo('top');
    });
  }
  /**
   * Move to the bottom of the grid
   *
   * @memberof NgxTreeGridRowDirective
   */
  moveToBottom() {
    this.handleWhenFocussed(() => {
      this.parent.moveTo('bottom');
    });
  }
  ngOnDestroy() {
    // Iben: Remove the row from the grid
    this.parent.removeRow(this.ngxTreeGridRow);
  }
  static {
    this.ɵfac = function NgxTreeGridRowDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTreeGridRowDirective)(i0.ɵɵdirectiveInject(NgxTreeGridDirective), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxTreeGridRowDirective,
      selectors: [["", "ngxTreeGridRow", ""]],
      hostVars: 1,
      hostBindings: function NgxTreeGridRowDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.ArrowUp", function NgxTreeGridRowDirective_keydown_ArrowUp_HostBindingHandler() {
            return ctx.moveUp();
          })("keydown.ArrowDown", function NgxTreeGridRowDirective_keydown_ArrowDown_HostBindingHandler() {
            return ctx.moveDown();
          })("keydown.ArrowRight", function NgxTreeGridRowDirective_keydown_ArrowRight_HostBindingHandler() {
            return ctx.arrowRight();
          })("keydown.ArrowLeft", function NgxTreeGridRowDirective_keydown_ArrowLeft_HostBindingHandler() {
            return ctx.arrowLeft();
          })("keydown.PageUp", function NgxTreeGridRowDirective_keydown_PageUp_HostBindingHandler() {
            return ctx.moveToTopPageUp();
          })("keydown.Home", function NgxTreeGridRowDirective_keydown_Home_HostBindingHandler() {
            return ctx.moveToTopHome();
          })("keydown.control.Home", function NgxTreeGridRowDirective_keydown_control_Home_HostBindingHandler() {
            return ctx.moveToTopControlHome();
          })("keydown.PageDown", function NgxTreeGridRowDirective_keydown_PageDown_HostBindingHandler() {
            return ctx.moveToBottomPageDown();
          })("keydown.End", function NgxTreeGridRowDirective_keydown_End_HostBindingHandler() {
            return ctx.moveToBottomEnd();
          })("keydown.control.End", function NgxTreeGridRowDirective_keydown_control_End_HostBindingHandler() {
            return ctx.moveToBottomControlEnd();
          })("keydown.shift.space", function NgxTreeGridRowDirective_keydown_shift_space_HostBindingHandler() {
            return ctx.selectRowShift();
          })("keydown.control.space", function NgxTreeGridRowDirective_keydown_control_space_HostBindingHandler() {
            return ctx.selectRowControl();
          })("keydown.shift.ArrowDown", function NgxTreeGridRowDirective_keydown_shift_ArrowDown_HostBindingHandler() {
            return ctx.selectNextRow();
          })("keydown.shift.ArrowUp", function NgxTreeGridRowDirective_keydown_shift_ArrowUp_HostBindingHandler() {
            return ctx.selectPreviousRow();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-expanded", ctx.ngxTreeGridRowExpanded);
        }
      },
      inputs: {
        ngxTreeGridRowExpanded: "ngxTreeGridRowExpanded",
        ngxTreeGridRow: "ngxTreeGridRow",
        ngxTreeGridRowSelectable: "ngxTreeGridRowSelectable"
      },
      outputs: {
        ngxTreeGridRowSelectRow: "ngxTreeGridRowSelectRow",
        ngxTreeGridRowExpandRow: "ngxTreeGridRowExpandRow"
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTreeGridRowDirective, [{
    type: Directive,
    args: [{
      selector: '[ngxTreeGridRow]',
      standalone: true
    }]
  }], () => [{
    type: NgxTreeGridDirective
  }, {
    type: i0.ElementRef
  }], {
    moveUp: [{
      type: HostListener,
      args: ['keydown.ArrowUp']
    }],
    moveDown: [{
      type: HostListener,
      args: ['keydown.ArrowDown']
    }],
    arrowRight: [{
      type: HostListener,
      args: ['keydown.ArrowRight']
    }],
    arrowLeft: [{
      type: HostListener,
      args: ['keydown.ArrowLeft']
    }],
    moveToTopPageUp: [{
      type: HostListener,
      args: ['keydown.PageUp']
    }],
    moveToTopHome: [{
      type: HostListener,
      args: ['keydown.Home']
    }],
    moveToTopControlHome: [{
      type: HostListener,
      args: ['keydown.control.Home']
    }],
    moveToBottomPageDown: [{
      type: HostListener,
      args: ['keydown.PageDown']
    }],
    moveToBottomEnd: [{
      type: HostListener,
      args: ['keydown.End']
    }],
    moveToBottomControlEnd: [{
      type: HostListener,
      args: ['keydown.control.End']
    }],
    selectRowShift: [{
      type: HostListener,
      args: ['keydown.shift.space']
    }],
    selectRowControl: [{
      type: HostListener,
      args: ['keydown.control.space']
    }],
    selectNextRow: [{
      type: HostListener,
      args: ['keydown.shift.ArrowDown']
    }],
    selectPreviousRow: [{
      type: HostListener,
      args: ['keydown.shift.ArrowUp']
    }],
    ngxTreeGridRowExpanded: [{
      type: HostBinding,
      args: ['attr.aria-expanded']
    }, {
      type: Input
    }],
    ngxTreeGridRow: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    ngxTreeGridRowSelectable: [{
      type: Input
    }],
    ngxTreeGridRowSelectRow: [{
      type: Output
    }],
    ngxTreeGridRowExpandRow: [{
      type: Output
    }]
  });
})();

/**
 * A cell directive to handle navigation according to the WCAG treegrid pattern
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/treegrid/
 */
class NgxTreeGridCellDirective extends NgxHasFocusDirective {
  /**
   * Set focus on the previous cell to the left
   */
  moveLeft(event) {
    this.handleWhenFocussed(() => {
      // Iben: Stop the event from bubbling so that the row does not open when navigating through the row (see arrowLeft in the NgxTreeGridRowDirective )
      if (this.ngxTreeGridCell === 0) {
        event.stopPropagation();
        return;
      }
      this.moveToCell(this.ngxTreeGridCell - 1, 'current');
    });
  }
  /**
   * Set focus on the next cell to the right
   */
  moveRight() {
    this.moveToCell(this.ngxTreeGridCell + 1, 'current');
  }
  /**
   * Set focus on the cell above
   */
  moveUp() {
    this.moveToCell(this.ngxTreeGridCell, 'above');
  }
  /**
   * Set focus on the cell below
   */
  moveDown() {
    this.moveToCell(this.ngxTreeGridCell, 'below');
  }
  /**
   * Set focus on the first cell of the grid
   */
  moveToFirstCellOfGrid() {
    this.moveToCell('first', 'first');
  }
  /**
   * Set focus on the first cell of the row
   */
  moveToFirstOfRow() {
    this.moveToCell('first', 'current');
  }
  /**
   * Set focus on the first cell of the same column of the grid
   */
  moveToFirstColumnOfGrid() {
    this.moveToCell(this.ngxTreeGridCell, 'first');
  }
  /**
   * Set focus on the last cell of the grid
   */
  moveToLastCellOfGrid() {
    this.moveToCell('last', 'last');
  }
  /**
   * Set focus on the last cell of the row
   */
  moveToBottomEnd() {
    this.moveToCell('last', 'current');
  }
  /**
   * Set focus on the last cell of the same column of the grid
   */
  moveToBottomControlEnd() {
    this.moveToCell(this.ngxTreeGridCell, 'last');
  }
  constructor(parent, elementRef) {
    super();
    this.parent = parent;
    this.elementRef = elementRef;
  }
  /**
   * Sets focus on the cell or on the first focusable item in the cell
   */
  focus() {
    // Iben: Check if any of the child elements are focusable
    const focusableElement = this.findFocusableElement();
    // Iben: If no element was focusable, focus on the current element
    if (!focusableElement) {
      this.elementRef.nativeElement.focus();
    }
  }
  /**
   * Moves focus to a provided cell in a provided row
   *
   * @private
   * @param cell - The cell we wish to put focus on
   * @param row - The row in which the cell is
   */
  moveToCell(cell, row) {
    this.handleWhenFocussed(() => {
      this.row.getCell(cell, row)?.focus();
    });
  }
  /**
   * Searches for a focusable element in the cell
   */
  findFocusableElement() {
    let result;
    // Iben: Loop over each first-level element of the children
    for (let element of [...this.elementRef.nativeElement.children]) {
      if (!result) {
        // Iben: Check if we can focus on the element
        element.focus();
        // Iben: If the current active element is the same as the element we focussed, on, we break
        if (element === document?.activeElement) {
          result = element;
          this.hasFocus = true;
          break;
        }
      }
    }
    return result;
  }
  ngAfterViewInit() {
    // Iben: We register the cell and the row through the parent, as the td elements are not rendered within the row initially.
    this.parent?.registerCell(this.ngxTreeGridCellRow, this);
    this.row = this.parent.getRow(this.ngxTreeGridCellRow);
  }
  static {
    this.ɵfac = function NgxTreeGridCellDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTreeGridCellDirective)(i0.ɵɵdirectiveInject(NgxTreeGridDirective, 8), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxTreeGridCellDirective,
      selectors: [["", "ngxTreeGridCell", ""]],
      hostVars: 1,
      hostBindings: function NgxTreeGridCellDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.ArrowLeft", function NgxTreeGridCellDirective_keydown_ArrowLeft_HostBindingHandler($event) {
            return ctx.moveLeft($event);
          })("keydown.ArrowRight", function NgxTreeGridCellDirective_keydown_ArrowRight_HostBindingHandler() {
            return ctx.moveRight();
          })("keydown.ArrowUp", function NgxTreeGridCellDirective_keydown_ArrowUp_HostBindingHandler() {
            return ctx.moveUp();
          })("keydown.ArrowDown", function NgxTreeGridCellDirective_keydown_ArrowDown_HostBindingHandler() {
            return ctx.moveDown();
          })("keydown.PageUp", function NgxTreeGridCellDirective_keydown_PageUp_HostBindingHandler() {
            return ctx.moveToFirstCellOfGrid();
          })("keydown.Home", function NgxTreeGridCellDirective_keydown_Home_HostBindingHandler() {
            return ctx.moveToFirstOfRow();
          })("keydown.control.Home", function NgxTreeGridCellDirective_keydown_control_Home_HostBindingHandler() {
            return ctx.moveToFirstColumnOfGrid();
          })("keydown.PageDown", function NgxTreeGridCellDirective_keydown_PageDown_HostBindingHandler() {
            return ctx.moveToLastCellOfGrid();
          })("keydown.End", function NgxTreeGridCellDirective_keydown_End_HostBindingHandler() {
            return ctx.moveToBottomEnd();
          })("keydown.control.End", function NgxTreeGridCellDirective_keydown_control_End_HostBindingHandler() {
            return ctx.moveToBottomControlEnd();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabIndex", -1);
        }
      },
      inputs: {
        ngxTreeGridCell: "ngxTreeGridCell",
        ngxTreeGridCellRow: "ngxTreeGridCellRow"
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTreeGridCellDirective, [{
    type: Directive,
    args: [{
      selector: '[ngxTreeGridCell]',
      standalone: true,
      host: {
        // Iben: Marks the cell as focusable, but only by setting its focus programmatically, not by the tab key
        '[attr.tabIndex]': '-1'
      }
    }]
  }], () => [{
    type: NgxTreeGridDirective,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i0.ElementRef
  }], {
    moveLeft: [{
      type: HostListener,
      args: ['keydown.ArrowLeft', ['$event']]
    }],
    moveRight: [{
      type: HostListener,
      args: ['keydown.ArrowRight']
    }],
    moveUp: [{
      type: HostListener,
      args: ['keydown.ArrowUp']
    }],
    moveDown: [{
      type: HostListener,
      args: ['keydown.ArrowDown']
    }],
    moveToFirstCellOfGrid: [{
      type: HostListener,
      args: ['keydown.PageUp']
    }],
    moveToFirstOfRow: [{
      type: HostListener,
      args: ['keydown.Home']
    }],
    moveToFirstColumnOfGrid: [{
      type: HostListener,
      args: ['keydown.control.Home']
    }],
    moveToLastCellOfGrid: [{
      type: HostListener,
      args: ['keydown.PageDown']
    }],
    moveToBottomEnd: [{
      type: HostListener,
      args: ['keydown.End']
    }],
    moveToBottomControlEnd: [{
      type: HostListener,
      args: ['keydown.control.End']
    }],
    ngxTreeGridCell: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    ngxTreeGridCellRow: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();
const NgxTreeGrid = [NgxTreeGridDirective, NgxTreeGridRowDirective, NgxTreeGridCellDirective];
class NgxTableComponent {
  /**
   * SETTER
   *
   * The current sorting event.
   */
  set currentSorting(event) {
    this.currentSortingEvent.set(event);
    this.handleCurrentSort(event);
  }
  /**
   * An optional key to open a row by default upon rendering.
   */
  set defaultRowOpen(openedIndex) {
    // Wouter: The function findIndex is most likely to be used. It returns
    // -1 if the index was not found.
    if (openedIndex < 0) {
      return;
    }
    // Wouter: This timeout is needed to wait for the TemplateRefs to be found.
    setTimeout(() => {
      this.handleRowClicked(this.data[openedIndex], openedIndex);
      this.cdRef.detectChanges();
    });
  }
  constructor(cdRef, ngxTableConfig) {
    this.cdRef = cdRef;
    this.ngxTableConfig = ngxTableConfig;
    /**
     * Default class that will be put on the ngx-table component
     */
    this.componentClass = this.ngxTableConfig?.ngxTableClass || '';
    /**
     * The loading state of our table
     */
    this.loading = false;
    /**
     * A subject to handle the observables when the component gets destroyed
     */
    this.destroyed$ = new Subject();
    /**
     * onTouch function for the control value accessor
     */
    this.onTouch = () => {};
    /**
     * onChanged function for the control value accessor
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.onChanged = _ => {};
    /**
     * Whether or not the form was generated
     */
    this.formGenerated = signal(false);
    /**
     * The current sorting event
     */
    this.currentSortingEvent = signal(undefined);
    /**
     * Keeps a record with the column and it's templates
     */
    this.tableCellTemplateRecord = signal({});
    /**
     * Keeps a record of which columns are sortable
     */
    this.sortableTableCellRecord = signal({});
    /**
     * Keeps a record of which cells have a cypress tag
     */
    this.tableCypressRecord = signal({});
    /**
     * Keeps a record of which cells are editable
     */
    this.editableTableCellRecord = signal({});
    /**
     * A set with all the open rows
     */
    // Iben: Sets are not supported in signals as signals are no longer mutable, hence why we keep them as is
    this.openRows = new Set();
    /**
     * A FormGroup that adds a control for each row
     */
    this.rowsFormGroup = new FormRecord({});
    /**
     * A control for the select all option in the header of the table
     */
    this.headerControl = new FormControl();
    /**
     * A control for when we use a radio button
     */
    this.radioControl = new FormControl();
    /**
     * A list of all defined columns
     */
    this.definedColumns = signal([]);
    /**
     * Whether or not there was a footer template set somewhere in one of the cells
     */
    this.hasFooterTemplates = signal(false);
    /**
     * Whether or not there was a row selected
     */
    this.selectedRow = signal(undefined);
    /**
     * An array of table columns
     */
    this.tableColumns = signal([]);
    /**
     * A list of all column names we want to represent in the table
     */
    this.columns = [];
    /**
     * An optional list of all columns we wish to attribute to row actions, which are sorted to the end of the row by default
     */
    this.actions = [];
    /**
     * The data we wish to render in the table
     */
    this.data = [];
    /**
     * An optional property that defines whether multiple rows can be open at once.
     * By default, this is false. The default can be overwritten in the NgxTableConfig.
     */
    this.allowMultipleOpenRows = this.ngxTableConfig?.allowMultipleRowsOpen || false;
    /**
     * Whether or not rows in the table are selectable
     */
    this.selectable = false;
    /**
     * In case the rows are selectable, we pass whether we want a radio button or a checkbox. By default, this is a checkbox
     */
    this.selectableType = 'checkbox';
    /**
     * In case the rows are selectable, we can determine whether we want to reset the form based on new data. Setting this to false will add new controls to the FormGroup; but will not remove the earlier controls from the form.
     * This is a useful feature for when the data is being filtered or new data is added through a load more mechanic
     *
     * By default, this is true. This default cannot be overwritten in the NgxTableConfig.
     */
    this.resetFormOnNewData = true;
    /**
     * An optional property to define whether we want to add a class to the currently opened row.
     * By default this is false. The default can be overwritten in the NgxTableConfig.
     */
    this.showSelectedOpenRow = this.ngxTableConfig?.showSelectedOpenRow || false;
    /**
     * An optional key that can be used in the data in order to highlight a row. If this property is present and true, the highlight class will be provided.
     * By default, this key is ngx-highlight. The default can be overwritten in the NgxTableConfig
     */
    this.highlightKey = this.ngxTableConfig?.highlightKey || 'ngx-highlight';
    /**
     * An optional property to define whether we want to show a visual indicator of the open and closed state of a detail row.
     * By default this is false. The default can be overwritten in the NgxTableConfig.
     */
    this.showOpenRowState = this.ngxTableConfig?.showOpenRowState || false;
    /**
     * An optional property to define the default open state of the detail row.
     * By default this is 'on-click'. The default can be overwritten in the NgxTableConfig.
     */
    this.showDetailRow = this.ngxTableConfig?.showDetailRow || 'on-click';
    /**
     * An optional property to define whether we want to emit the row when there's only one item in the table and the showDetailRow is set to `on-single-item`
     * By default this is false. The default can be overwritten in the NgxTableConfig.
     */
    this.emitValueOnSingleItem = this.ngxTableConfig?.showDetailRow === 'on-single-item' && this.ngxTableConfig?.emitValueOnSingleItem;
    /**
     * An optional property to define whether we want the header to be hidden in certain cases.
     * By default this is never. The default can be overwritten in the NgxTableConfig
     */
    this.hideHeaderWhen = this.ngxTableConfig?.hideHeaderWhen || 'never';
    /**
     * Returns the data of the row that was clicked
     */
    this.rowClicked = new EventEmitter();
  }
  /**
   * WriteValue method for the value accessor
   *
   * @param value - The value patched to the control
   */
  writeValue(value) {
    // Iben: In case we're using radio buttons, we set the radio control and early exit
    if (this.selectableType === 'radio') {
      this.radioControl.patchValue(value, {
        emitEvent: false
      });
      return;
    }
    // Iben: Reset the form
    this.rowsFormGroup.reset({}, {
      emitEvent: false
    });
    // Iben: Early exit if the value is empty or not an array
    if (!Array.isArray(value) || value.length === 0) {
      return;
    }
    // Iben: Patch the value to the form
    this.rowsFormGroup.patchValue(writeNgxTableValue(value, this.selectableKey), {
      emitEvent: false
    });
    // Wouter: Some rows are not selected, so uncheck the header checkbox
    if (Object.values(this.rowsFormGroup.controls).some(control => !Boolean(control?.value))) {
      this.headerControl.patchValue(false, {
        emitEvent: false
      });
      return;
    }
    // Wouter: Set the header checkbox to `checked`, because all rows are selected
    this.headerControl.patchValue(true, {
      emitEvent: false
    });
  }
  /**
   * Register the onChange function
   */
  registerOnChange(fn) {
    this.onChanged = fn;
  }
  /**
   * Register the onTouched function
   */
  registerOnTouched(fn) {
    this.onTouch = fn;
  }
  /**
   * Handle the disabled state of the form
   *
   * @param  isDisabled - Whether or not the form is disabled
   */
  setDisabledState(isDisabled) {
    if (isDisabled) {
      this.rowsFormGroup.disable({
        emitEvent: false
      });
      this.headerControl.disable({
        emitEvent: false
      });
      this.radioControl.disable({
        emitEvent: false
      });
    } else {
      this.rowsFormGroup.enable({
        emitEvent: false
      });
      this.headerControl.enable({
        emitEvent: false
      });
      this.radioControl.enable({
        emitEvent: false
      });
    }
  }
  /**
   * Handle a click on a row
   *
   * @param row - The data of the row that was clicked
   * @param index - The index of the row that was clicked
   */
  handleRowClicked(row, index) {
    // Iben: Emit a row click event
    this.rowClicked.emit(row);
    // Iben: Handle the selected open row if needed
    if (this.showSelectedOpenRow) {
      if (this.selectedRow() === index) {
        // Benoit: If you close the selected row, unselect that row
        this.selectedRow.set(undefined);
      } else {
        this.selectedRow.set(index);
      }
    }
    // Iben: Handle the row state
    this.handleRowState(index, !this.openRows.has(index) ? 'open' : 'close');
  }
  /**
   * Handle the expanded state of a row
   *
   * @param index - The index of the row
   * @param action - Whether the row needs to be opened or closed
   */
  handleRowState(index, action) {
    // Iben: If there's no detail row we early exit
    if (!this.detailRowTemplate) {
      return;
    }
    // Iben: Depending on whether we allow multiple rows to be open at the same time, we toggle the open rows accordingly
    if (this.allowMultipleOpenRows) {
      action === 'open' ? this.openRows.add(index) : this.openRows.delete(index);
    } else {
      this.openRows = action === 'open' ? new Set([index]) : new Set();
    }
  }
  /**
   * Assigns the templates of each cell to the correct columns
   */
  handleTableCellTemplates() {
    // Iben: Reset the provided records
    this.tableCellTemplateRecord.set({});
    this.sortableTableCellRecord.set({});
    this.tableCypressRecord.set({});
    this.editableTableCellRecord.set({});
    // Iben: Loop over all provided table cell templates
    Array.from(this.tableCellTemplates).forEach(tableCellTemplate => {
      // Iben: Early exit in case for some reason the template is undefined
      if (!tableCellTemplate) {
        return;
      }
      // Iben: Add the template to the template record for easy access in the table template
      const {
        column,
        headerTemplate,
        cellTemplate,
        footerTemplate,
        sortable,
        cellClass,
        cypressDataTags,
        editable
      } = tableCellTemplate;
      this.tableCellTemplateRecord.update(value => {
        return {
          ...value,
          [column]: {
            headerTemplate,
            cellTemplate,
            footerTemplate,
            cellClass
          }
        };
      });
      // Iben: If the column is sortable, we add it to the sortable record
      if (sortable) {
        this.sortableTableCellRecord.update(value => {
          return {
            ...value,
            [column]: tableCellTemplate
          };
        });
      }
      // Iben: If the column has cypress tags, we add them to the record
      if (cypressDataTags) {
        this.tableCypressRecord.update(value => {
          return {
            ...value,
            [column]: cypressDataTags
          };
        });
      }
      // Iben: If the cell is editable, we add it to the record
      if (editable) {
        this.editableTableCellRecord.update(value => {
          return {
            ...value,
            [column]: tableCellTemplate
          };
        });
      }
    });
    // Iben: Check if at least one template has a footer template, so that we know whether or not we have to render the footer row
    this.hasFooterTemplates.set(Array.from(this.tableCellTemplates).some(cellTemplate => Boolean(cellTemplate.footerTemplate)));
    // Iben:
    this.handleCurrentSort(this.currentSortingEvent());
    // Iben: Detect changes to update the view
    this.cdRef.detectChanges();
  }
  /**
   * Respond to a click on the sort of a column
   *
   * @param column - The column we clicked on
   */
  handleSort(column) {
    // Iben: If the column is not sortable we early exit
    if (!this.sortableTableCellRecord()[column]) {
      return;
    }
    // Iben: Loop over the sortable columns and reset all columns that don't match with the clicked column
    Object.entries(this.sortableTableCellRecord()).forEach(([cellName, cell]) => {
      if (cellName === column) {
        this.sortableTableCellRecord()[column].handleSort();
      } else {
        cell.resetSortDirection();
      }
    });
  }
  selectRow(index) {
    this.rowsFormGroup.get(this.selectableKey ? `${this.data[index][this.selectableKey]}` : `${index}`).patchValue(true);
  }
  /**
   * Handle the changes in sort events
   *
   * @param event - The new sorting event
   */
  handleCurrentSort(event) {
    // Iben: Early exit if the sortable cell record is empty or if the cell already has the sortDirection of the event
    if (isEmpty(this.sortableTableCellRecord() || event && this.sortableTableCellRecord()[event.column].sortDirection === event.direction)) {
      return;
    }
    // Iben: We reset all the sort directions by default, so all of them are unsorted.
    Object.values(this.sortableTableCellRecord()).forEach(cell => cell.resetSortDirection());
    // Iben: If there's no sort event passed, we early exit
    if (!event) {
      return;
    }
    // Iben: In case there was a sorting provided and we set the sorting to the provided column and direction
    this.sortableTableCellRecord()[event.column].setSortDirection(event.direction);
  }
  /**
   * Setup the columns array
   */
  handleRowColumns() {
    // Iben: Make sure that the select option, the open row state and the defined actions are correctly placed
    this.definedColumns.set([...(this.selectable ? ['ngxTableSelectColumn'] : []), ...(this.columns || []), ...(this.actions || []), ...(this.showOpenRowState && this.detailRowTemplate ? ['ngxOpenRowStateColumn'] : [])]);
    // Iben: Set the actual table columns
    this.tableColumns.set([...(this.columns || []), ...(this.actions || [])]);
  }
  // Lifecycle methods
  // ==============================
  ngAfterContentChecked() {
    // Iben: Run with content check so that we can dynamically add templates/columns
    this.handleRowColumns();
    this.handleTableCellTemplates();
  }
  ngOnChanges(changes) {
    if (changes.data) {
      // Wouter: Deselect any row that was selected to prevent faulty class toggle.
      this.selectedRow.set(undefined);
    }
    // Iben: Setup the form when the data or selectable state changes
    if ((changes.data || changes.selectable) && this.selectable) {
      // Iben: If no form was generated, first generate the form we need
      if (!this.formGenerated()) {
        generateNgxTableForm(this.rowsFormGroup, this.data, this.selectableKey);
        this.formGenerated.set(true);
      } else {
        // Iben: If a form was generated, reset it as required
        resetNgxTableForm(this.rowsFormGroup, this.data, this.selectableKey, this.resetFormOnNewData);
      }
    }
    // Iben: Add the selectableColumn if the rows are selectable and add an open row state when needed
    if (changes.selectable || changes.columns || changes.showOpenRowState) {
      this.handleRowColumns();
    }
    // Iben: If there's only one item in the data and we open the detail row by default, we emit the row clicked value
    if (this.emitValueOnSingleItem && changes.data?.currentValue.length === 1 && this.showDetailRow === 'on-single-item') {
      this.handleRowClicked(changes.data.currentValue[0], 0);
    }
    // Iben: Reset the open rows if the amount of items are no longer the same
    if (changes.data && changes.data.previousValue?.length !== changes.data.currentValue?.length) {
      this.openRows = new Set();
    }
  }
  ngOnInit() {
    // Iben: Subscribe to the form to handle the selectable behavior
    this.rowsFormGroup.valueChanges.pipe(tap(value => {
      // Iben: If not all items are selected, we uncheck the headerControl without emitting a value to prevent an infinite loop in the next subscription
      this.headerControl.setValue(Object.values(value).every(selected => selected), {
        emitEvent: false
      });
      // Iben: Emit the current selection and mark the form as touched\
      this.onChanged(handleNgxTableValueChanges(value));
      this.onTouch();
    }), takeUntil(this.destroyed$)).subscribe();
    // Iben: Listen to the radio control and update the value accordingly
    this.radioControl.valueChanges.pipe(tap(value => {
      this.onChanged(value);
      this.onTouch();
    }), takeUntil(this.destroyed$)).subscribe();
    // Iben: Subscribe to the headerControl to handle multiSelect behaviour
    this.headerControl.valueChanges.pipe(tap(selected => {
      // Iben: Select all items when this control is selected, if not, unselect them all
      if (selected) {
        this.rowsFormGroup.patchValue(handleNgxTableHeaderValueChanges(this.rowsFormGroup));
      } else {
        this.rowsFormGroup.reset();
      }
    }), takeUntil(this.destroyed$)).subscribe();
  }
  ngOnDestroy() {
    this.destroyed$.next(null);
    this.destroyed$.complete();
  }
  static {
    this.ɵfac = function NgxTableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxTableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NgxTableConfigToken, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgxTableComponent,
      selectors: [["ngx-table"]],
      contentQueries: function NgxTableComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c3, 5);
          i0.ɵɵcontentQuery(dirIndex, _c4, 5);
          i0.ɵɵcontentQuery(dirIndex, _c5, 5);
          i0.ɵɵcontentQuery(dirIndex, _c6, 5);
          i0.ɵɵcontentQuery(dirIndex, _c7, 5);
          i0.ɵɵcontentQuery(dirIndex, _c8, 5);
          i0.ɵɵcontentQuery(dirIndex, _c9, 5);
          i0.ɵɵcontentQuery(dirIndex, NgxAbstractTableCellDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.detailRowTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loadingTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.radioTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.openRowStateTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableCellTemplates = _t);
        }
      },
      hostVars: 3,
      hostBindings: function NgxTableComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵhostProperty("ngx-table-loading", ctx.loading);
          i0.ɵɵclassMap(ctx.componentClass);
        }
      },
      inputs: {
        loading: "loading",
        columns: "columns",
        actions: "actions",
        data: "data",
        allowMultipleOpenRows: "allowMultipleOpenRows",
        selectable: "selectable",
        selectableKey: "selectableKey",
        selectableType: "selectableType",
        resetFormOnNewData: "resetFormOnNewData",
        currentSorting: "currentSorting",
        showSelectedOpenRow: "showSelectedOpenRow",
        rowClass: "rowClass",
        highlightKey: "highlightKey",
        showOpenRowState: "showOpenRowState",
        showDetailRow: "showDetailRow",
        emitValueOnSingleItem: "emitValueOnSingleItem",
        defaultRowOpen: "defaultRowOpen",
        hideHeaderWhen: "hideHeaderWhen"
      },
      outputs: {
        rowClicked: "rowClicked"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: NgxTableComponent
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 20,
      vars: 25,
      consts: [["detailRowTmpl", ""], ["checkboxTmpl", ""], ["radioButtonTmpl", ""], ["defaultOpenRowStateTmpl", ""], ["cdk-table", "", "multiTemplateDataRows", "", "fixedLayout", "", 1, "ngx-table", 3, "ngxTreeGrid", "ngxTreeGridExpandable", "dataSource"], ["cdkColumnDef", "ngxTableSelectColumn"], ["cdkColumnDef", "ngxOpenRowStateColumn"], [3, "cdkColumnDef"], ["cdkColumnDef", "ngxTableDetailColumn"], ["cdk-header-row", ""], ["class", "ngx-table-cell ngx-table-header-cell ngx-table-selectable-cell", "cdk-header-cell", "", 4, "cdkHeaderCellDef"], ["class", "ngx-table-cell ngx-table-row-cell ngx-table-selectable-cell", 3, "ngxTreeGridCell", "ngxTreeGridCellRow", 4, "cdkCellDef"], ["class", "ngx-table-cell ngx-table-footer-cell", "cdk-footer-cell", "", 4, "cdkFooterCellDef"], ["cdk-header-cell", "", 1, "ngx-table-cell", "ngx-table-header-cell", "ngx-table-selectable-cell"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ngx-table-cell", "ngx-table-row-cell", "ngx-table-selectable-cell", 3, "ngxTreeGridCell", "ngxTreeGridCellRow"], ["cdk-footer-cell", "", 1, "ngx-table-cell", "ngx-table-footer-cell"], ["class", "ngx-table-cell ngx-table-header-cell", "cdk-header-cell", "", 4, "cdkHeaderCellDef"], ["class", "ngx-table-cell ngx-table-row-cell ngx-table-open-row-state-cell", 3, "ngxTreeGridCell", "ngxTreeGridCellRow", "click", 4, "cdkCellDef"], ["cdk-header-cell", "", 1, "ngx-table-cell", "ngx-table-header-cell"], [1, "ngx-table-cell", "ngx-table-row-cell", "ngx-table-open-row-state-cell", 3, "click", "ngxTreeGridCell", "ngxTreeGridCellRow"], ["cdk-header-cell", "", 3, "ngClass", "ngx-table-sortable-cell", 4, "cdkHeaderCellDef"], ["cdk-cell", "", 3, "ngClass", "ngxTreeGridCell", "ngxTreeGridCellRow", "click", 4, "cdkCellDef"], ["cdk-header-cell", "", 3, "ngClass"], [1, "ngx-table-sorting-cell-button"], [1, "ngx-table-sorting-cell-button", 3, "click"], [3, "ngTemplateOutlet"], [1, "ngx-table-sorting-icon", 3, "innerHtml"], ["cdk-cell", "", 3, "click", "ngClass", "ngxTreeGridCell", "ngxTreeGridCellRow"], ["class", "ngx-table-cell ngx-table-detail-cell", "cdk-cell", "", 4, "cdkCellDef"], ["cdk-cell", "", 1, "ngx-table-cell", "ngx-table-detail-cell"], ["cdk-header-row", "", 4, "cdkHeaderRowDef"], ["cdk-row", "", "aria-level", "1", 3, "ngClass", "ngx-table-row-odd", "ngx-table-row-even", "ngx-table-row-selected", "ngxTreeGridRow", "ngxTreeGridRowSelectable", "ngxTreeGridRowExpanded", "ngxTreeGridRowSelectRow", "ngxTreeGridRowExpandRow", "keydown.enter", 4, "cdkRowDef", "cdkRowDefColumns"], ["cdk-row", "", "aria-level", "2", "aria-posinset", "1", 1, "ngx-table-detail-row", 3, "ngx-table-detail-row-open"], ["cdk-footer-row", "", 1, "ngx-table-footer-row"], ["cdk-row", "", "aria-level", "1", 3, "ngxTreeGridRowSelectRow", "ngxTreeGridRowExpandRow", "keydown.enter", "ngClass", "ngxTreeGridRow", "ngxTreeGridRowSelectable", "ngxTreeGridRowExpanded"], ["class", "ngx-table-detail-row", "cdk-row", "", "aria-level", "2", "aria-posinset", "1", 3, "ngx-table-detail-row-open", 4, "cdkRowDef", "cdkRowDefColumns"], ["cdk-row", "", "aria-level", "2", "aria-posinset", "1", 1, "ngx-table-detail-row"], ["class", "ngx-table-footer-row", "cdk-footer-row", "", 4, "cdkFooterRowDef"], ["type", "checkbox", 1, "ngx-table-checkbox", 3, "formControl"], ["type", "radio", "name", "ngx-table-radio", 1, "ngx-table-radio", 3, "id", "value", "formControl"], ["tabindex", "1", 1, "ngx-table-open-state-icon", 3, "innerHtml"]],
      template: function NgxTableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 4);
          i0.ɵɵpipe(1, "ngxTableHasObservers");
          i0.ɵɵtemplate(2, NgxTableComponent_Conditional_2_Template, 4, 0, "ng-container", 5)(3, NgxTableComponent_Conditional_3_Template, 4, 0, "ng-container", 6);
          i0.ɵɵrepeaterCreate(4, NgxTableComponent_For_5_Template, 4, 1, "ng-container", 7, i0.ɵɵrepeaterTrackByIdentity);
          i0.ɵɵtemplate(6, NgxTableComponent_Conditional_6_Template, 2, 0, "ng-container", 8)(7, NgxTableComponent_Conditional_7_Template, 1, 1, "tr", 9);
          i0.ɵɵpipe(8, "ngxTableShowHeader");
          i0.ɵɵtemplate(9, NgxTableComponent_Conditional_9_Template, 3, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, NgxTableComponent_Conditional_10_Template, 2, 1, "div")(11, NgxTableComponent_Conditional_11_Template, 2, 1, "div")(12, NgxTableComponent_ng_template_12_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(14, NgxTableComponent_ng_template_14_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(16, NgxTableComponent_ng_template_16_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(18, NgxTableComponent_ng_template_18_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("ngx-table-hide-rows", ctx.loading || (ctx.data || i0.ɵɵpureFunction0(20, _c10)).length === 0)("ngx-table-clickable-rows", ctx.detailRowTemplate || i0.ɵɵpipeBind1(1, 15, ctx.rowClicked));
          i0.ɵɵproperty("ngxTreeGrid", ctx.detailRowTemplate !== undefined || ctx.selectable)("ngxTreeGridExpandable", ctx.detailRowTemplate !== undefined)("dataSource", !ctx.loading ? ctx.data : i0.ɵɵpureFunction0(21, _c10));
          i0.ɵɵattribute("aria-multiselectable", ctx.selectableType === "checkbox");
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.selectable ? 2 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.showOpenRowState ? 3 : -1);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.tableColumns());
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.detailRowTemplate ? 6 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(i0.ɵɵpipeBind2(8, 17, i0.ɵɵpureFunction2(22, _c11, ctx.loading, (ctx.data == null ? null : ctx.data.length) === 0), ctx.hideHeaderWhen) ? 7 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.data ? 9 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(!ctx.loading && (!ctx.data || ctx.data.length === 0) ? 10 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.loading ? 11 : -1);
        }
      },
      dependencies: [CdkTableModule, i1.CdkTable, i1.CdkRowDef, i1.CdkCellDef, i1.CdkHeaderCellDef, i1.CdkFooterCellDef, i1.CdkColumnDef, i1.CdkCell, i1.CdkRow, i1.CdkHeaderCell, i1.CdkFooterCell, i1.CdkHeaderRow, i1.CdkHeaderRowDef, i1.CdkFooterRow, i1.CdkFooterRowDef, NgTemplateOutlet, NgClass, ReactiveFormsModule, i2.DefaultValueAccessor, i2.CheckboxControlValueAccessor, i2.RadioControlValueAccessor, i2.NgControlStatus, i2.FormControlDirective, NgxTableHasObserversPipe, NgxTableSortIconPipe, NgxTableShowHeaderPipe, NgxAriaSortPipe, NgxTreeGridDirective, NgxTreeGridRowDirective, NgxTreeGridCellDirective],
      styles: ["[_nghost-%COMP%]{display:block;width:100%;height:100%}[_nghost-%COMP%]   .ngx-table[_ngcontent-%COMP%]{width:100%;height:100%;border-spacing:0px;border-top:1px solid black;border-left:1px solid black}[_nghost-%COMP%]   .ngx-table.ngx-table-hide-rows[_ngcontent-%COMP%]   .ngx-table-row[_ngcontent-%COMP%], [_nghost-%COMP%]   .ngx-table.ngx-table-hide-rows[_ngcontent-%COMP%]   .ngx-table-footer-row[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   .ngx-table.ngx-table-clickable-rows[_ngcontent-%COMP%]   .ngx-table-row[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]   .ngx-table-selectable-cell[_ngcontent-%COMP%]{width:25px;text-align:center}[_nghost-%COMP%]   .ngx-table-sortable-cell[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]   .ngx-table-sortable-cell[_ngcontent-%COMP%]   .ngx-table-sorting-cell-button[_ngcontent-%COMP%]{width:100%;height:100%;padding:0;font-weight:inherit;background-color:transparent;border:none}[_nghost-%COMP%]   .ngx-table-sortable-cell[_ngcontent-%COMP%]   .ngx-table-sorting-icon[_ngcontent-%COMP%]{font-style:normal}[_nghost-%COMP%]   .ngx-table-open-row-state-cell[_ngcontent-%COMP%]{width:50px}[_nghost-%COMP%]   .ngx-table-open-row-state-cell[_ngcontent-%COMP%]   .ngx-table-open-state-icon[_ngcontent-%COMP%]{font-style:normal}[_nghost-%COMP%]   .ngx-table-open-row-state-cell[_ngcontent-%COMP%]   .ngx-table-open-state-icon.is-reversed[_ngcontent-%COMP%]{transform:rotate(180deg)}[_nghost-%COMP%]   .ngx-table-cell[_ngcontent-%COMP%]{padding:15px;border-right:1px solid black;border-bottom:1px solid black}[_nghost-%COMP%]   .ngx-table-detail-row[_ngcontent-%COMP%]:not(.ngx-table-detail-row-open){display:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxTableComponent, [{
    type: Component,
    args: [{
      selector: 'ngx-table',
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: NgxTableComponent
      }],
      imports: [CdkTableModule, NgTemplateOutlet, NgClass, ReactiveFormsModule, NgxTableHasObserversPipe, NgxTableSortIconPipe, NgxTableShowHeaderPipe, NgxAriaSortPipe, NgxTreeGrid],
      template: "<table\n\tclass=\"ngx-table\"\n\tcdk-table\n\tmultiTemplateDataRows\n\tfixedLayout\n\t[ngxTreeGrid]=\"detailRowTemplate !== undefined || selectable\"\n\t[ngxTreeGridExpandable]=\"detailRowTemplate !== undefined\"\n\t[class.ngx-table-hide-rows]=\"loading || (data || []).length === 0\"\n\t[class.ngx-table-clickable-rows]=\"detailRowTemplate || (rowClicked | ngxTableHasObservers)\"\n\t[attr.aria-multiselectable]=\"selectableType === 'checkbox'\"\n\t[dataSource]=\"!loading ? data : []\"\n>\n\t@if (selectable) {\n\t<ng-container cdkColumnDef=\"ngxTableSelectColumn\">\n\t\t<th\n\t\t\t*cdkHeaderCellDef\n\t\t\tclass=\"ngx-table-cell ngx-table-header-cell ngx-table-selectable-cell\"\n\t\t\tcdk-header-cell\n\t\t\t[attr.aria-readonly]=\"headerControl.disabled\"\n\t\t>\n\t\t\t@if (selectableType === 'checkbox') {\n\t\t\t<ng-template\n\t\t\t\t[ngTemplateOutlet]=\"checkboxTmpl\"\n\t\t\t\t[ngTemplateOutletContext]=\"{\n\t\t\t\t\t$implicit: headerControl,\n\t\t\t\t\trow: undefined,\n\t\t\t\t\tindex: undefined\n\t\t\t\t}\"\n\t\t\t>\n\t\t\t</ng-template>\n\t\t\t}\n\t\t</th>\n\t\t<td\n\t\t\t*cdkCellDef=\"let row; let index = dataIndex\"\n\t\t\tclass=\"ngx-table-cell ngx-table-row-cell ngx-table-selectable-cell\"\n\t\t\t[ngxTreeGridCell]=\"0\"\n\t\t\t[ngxTreeGridCellRow]=\"index\"\n\t\t>\n\t\t\t@if ( selectableType === 'radio' || (selectableType === 'checkbox' &&\n\t\t\trowsFormGroup.controls[ this.selectableKey ? row[selectableKey] : index ]); as control )\n\t\t\t{\n\t\t\t<ng-template\n\t\t\t\t[ngTemplateOutlet]=\"selectableType === 'checkbox' ? checkboxTmpl : radioButtonTmpl\"\n\t\t\t\t[ngTemplateOutletContext]=\"{\n\t\t\t\t\t$implicit: control,\n\t\t\t\t\trow: row,\n\t\t\t\t\tindex: index\n\t\t\t\t}\"\n\t\t\t>\n\t\t\t</ng-template>\n\t\t\t}\n\t\t</td>\n\t\t<td\n\t\t\t*cdkFooterCellDef=\"let row\"\n\t\t\tclass=\"ngx-table-cell ngx-table-footer-cell\"\n\t\t\tcdk-footer-cell\n\t\t></td>\n\t</ng-container>\n\t} @if (showOpenRowState) {\n\t<ng-container cdkColumnDef=\"ngxOpenRowStateColumn\">\n\t\t<th *cdkHeaderCellDef class=\"ngx-table-cell ngx-table-header-cell\" cdk-header-cell></th>\n\t\t<td\n\t\t\t*cdkCellDef=\"let row; let index = dataIndex\"\n\t\t\tclass=\"ngx-table-cell ngx-table-row-cell ngx-table-open-row-state-cell\"\n\t\t\t[ngxTreeGridCell]=\"selectable ? columns.length + 1 : columns.length + 2\"\n\t\t\t[ngxTreeGridCellRow]=\"index\"\n\t\t\t(click)=\"handleRowClicked(row, index)\"\n\t\t>\n\t\t\t<ng-template\n\t\t\t\t[ngTemplateOutlet]=\"openRowStateTemplate || defaultOpenRowStateTmpl\"\n\t\t\t\t[ngTemplateOutletContext]=\"{\n\t\t\t\t\t$implicit:\n\t\t\t\t\t\tshowDetailRow === 'always' ||\n\t\t\t\t\t\t(showDetailRow === 'on-single-item' && data?.length === 1) ||\n\t\t\t\t\t\topenRows.has(index)\n\t\t\t\t}\"\n\t\t\t>\n\t\t\t</ng-template>\n\t\t</td>\n\t\t<td\n\t\t\t*cdkFooterCellDef=\"let row\"\n\t\t\tclass=\"ngx-table-cell ngx-table-footer-cell\"\n\t\t\tcdk-footer-cell\n\t\t></td>\n\t</ng-container>\n\t} @for (column of tableColumns(); track column; let columnIndex = $index) {\n\t<ng-container [cdkColumnDef]=\"column\">\n\t\t<th\n\t\t\t*cdkHeaderCellDef\n\t\t\tcdk-header-cell\n\t\t\t[ngClass]=\"[\n\t\t\t\t'ngx-table-cell',\n\t\t\t\t'ngx-table-header-cell',\n\t\t\t\ttableCellTemplateRecord()[column]?.cellClass || ''\n\t\t\t]\"\n\t\t\t[class.ngx-table-sortable-cell]=\"sortableTableCellRecord()[column]\"\n\t\t\t[attr.data-cy]=\"tableCypressRecord()[column]?.header || ''\"\n\t\t\t[attr.aria-sort]=\"\n\t\t\t\t{ currentSorting: currentSortingEvent(), cell: sortableTableCellRecord()[column] }\n\t\t\t\t\t| ngxAriaSort\n\t\t\t\"\n\t\t\t[attr.aria-readonly]=\"!sortableTableCellRecord()[column]\"\n\t\t>\n\t\t\t<!-- Wouter: Check if header is sortable -->\n\t\t\t@if( sortableTableCellRecord()[column]; as sortCell) {\n\t\t\t<!-- Wouter: If so: wrap button element around content -->\n\t\t\t<button (click)=\"handleSort(column)\" class=\"ngx-table-sorting-cell-button\">\n\t\t\t\t@if ( tableCellTemplateRecord()[column]?.headerTemplate) {\n\t\t\t\t<!-- Wouter: Check if a custom template has been provided -->\n\t\t\t\t<ng-template [ngTemplateOutlet]=\"tableCellTemplateRecord()[column].headerTemplate\">\n\t\t\t\t</ng-template>\n\t\t\t\t} @else {\n\t\t\t\t<!-- Wouter: If not: display passed column name -->\n\t\t\t\t{{ column }}\n\t\t\t\t} @if (sortTemplate) {\n\t\t\t\t<!-- Wouter: Check if a custom sorting template has been provided -->\n\t\t\t\t<ng-template\n\t\t\t\t\t[ngTemplateOutlet]=\"sortTemplate\"\n\t\t\t\t\t[ngTemplateOutletContext]=\"{\n\t\t\t\t\t\t$implicit: sortCell.sortDirection ? sortCell.sortDirection.toString() : null\n\t\t\t\t\t}\"\n\t\t\t\t>\n\t\t\t\t</ng-template>\n\t\t\t\t} @else {\n\t\t\t\t<i\n\t\t\t\t\tclass=\"ngx-table-sorting-icon\"\n\t\t\t\t\t[innerHtml]=\"sortCell.sortDirection | ngxTableSortIcon\"\n\t\t\t\t></i>\n\t\t\t\t}\n\t\t\t</button>\n\t\t\t} @else { @if ( tableCellTemplateRecord()[column]?.headerTemplate) {\n\t\t\t<!-- Wouter: Check if a custom template has been provided -->\n\t\t\t<ng-template [ngTemplateOutlet]=\"tableCellTemplateRecord()[column].headerTemplate\">\n\t\t\t</ng-template>\n\t\t\t} @else {\n\t\t\t<!-- Wouter: If not: display passed column name -->\n\t\t\t{{ column }}\n\t\t\t} }\n\t\t</th>\n\t\t<td\n\t\t\t*cdkCellDef=\"let row; let index = dataIndex\"\n\t\t\tcdk-cell\n\t\t\t[ngClass]=\"[\n\t\t\t\t'ngx-table-cell',\n\t\t\t\t'ngx-table-row-cell',\n\t\t\t\ttableCellTemplateRecord()[column]?.cellClass || ''\n\t\t\t]\"\n\t\t\t[ngxTreeGridCell]=\"selectable ? columnIndex + 1 : columnIndex\"\n\t\t\t[ngxTreeGridCellRow]=\"index\"\n\t\t\t[attr.data-cy]=\"tableCypressRecord()[column]?.cell || ''\"\n\t\t\t[attr.role]=\"detailRowTemplate ? 'gridcell' : 'cell'\"\n\t\t\t[attr.aria-readonly]=\"!editableTableCellRecord()[column]\"\n\t\t\t(click)=\"handleRowClicked(row, index)\"\n\t\t>\n\t\t\t@if (tableCellTemplateRecord()[column]?.cellTemplate) {\n\t\t\t<ng-template\n\t\t\t\t[ngTemplateOutlet]=\"tableCellTemplateRecord()[column].cellTemplate\"\n\t\t\t\t[ngTemplateOutletContext]=\"{\n\t\t\t\t\t$implicit: row[column],\n\t\t\t\t\trow: row,\n\t\t\t\t\tindex: index,\n\t\t\t\t\tisRowOpen:\n\t\t\t\t\t\tshowDetailRow === 'always' ||\n\t\t\t\t\t\t(showDetailRow === 'on-single-item' && data?.length === 1) ||\n\t\t\t\t\t\topenRows.has(index)\n\t\t\t\t}\"\n\t\t\t>\n\t\t\t</ng-template>\n\t\t\t} @else {\n\t\t\t{{ row[column] }}\n\t\t\t}\n\t\t</td>\n\t\t<td\n\t\t\t*cdkFooterCellDef=\"let row\"\n\t\t\tclass=\"ngx-table-cell ngx-table-footer-cell\"\n\t\t\t[attr.data-cy]=\"tableCypressRecord()[column]?.footer || ''\"\n\t\t\tcdk-footer-cell\n\t\t>\n\t\t\t@if (tableCellTemplateRecord()[column]?.footerTemplate) {\n\t\t\t<ng-template [ngTemplateOutlet]=\"tableCellTemplateRecord()[column].footerTemplate\">\n\t\t\t</ng-template>\n\t\t\t}\n\t\t</td>\n\t</ng-container>\n\t} @if (detailRowTemplate) {\n\t<ng-container cdkColumnDef=\"ngxTableDetailColumn\">\n\t\t<td\n\t\t\t*cdkCellDef=\"let row; let index = dataIndex\"\n\t\t\tclass=\"ngx-table-cell ngx-table-detail-cell\"\n\t\t\tcdk-cell\n\t\t\t[attr.colspan]=\"definedColumns().length\"\n\t\t>\n\t\t\t<ng-template\n\t\t\t\t[ngTemplateOutlet]=\"detailRowTmpl\"\n\t\t\t\t[ngTemplateOutletContext]=\"{ $implicit: row, index: index }\"\n\t\t\t>\n\t\t\t</ng-template>\n\t\t</td>\n\t</ng-container>\n\t} @if ( { isLoading: loading, isEmpty: data?.length === 0 } | ngxTableShowHeader :\n\thideHeaderWhen ) {\n\t<tr *cdkHeaderRowDef=\"definedColumns()\" cdk-header-row></tr>\n\t} @if (data) {\n\t<tr\n\t\t*cdkRowDef=\"let row; columns: definedColumns(); let rowIndex = dataIndex\"\n\t\tcdk-row\n\t\t[attr.tabindex]=\"detailRowTemplate !== undefined || selectable ? 0 : -1\"\n\t\taria-level=\"1\"\n\t\t[attr.aria-setsize]=\"detailRowTemplate ? 1 : 0\"\n\t\t[ngClass]=\"[\n\t\t\t'ngx-table-row',\n\t\t\trowClass || '',\n\t\t\trow[highlightKey] ? 'ngx-table-row-highlight' : ''\n\t\t]\"\n\t\t[class.ngx-table-row-odd]=\"rowIndex % 2 !== 0\"\n\t\t[class.ngx-table-row-even]=\"rowIndex % 2 === 0\"\n\t\t[class.ngx-table-row-selected]=\"\n\t\t\tshowSelectedOpenRow &&\n\t\t\t(selectedRow === rowIndex || (showDetailRow === 'on-single-item' && data?.length === 1))\n\t\t\"\n\t\t[ngxTreeGridRow]=\"rowIndex\"\n\t\t[ngxTreeGridRowSelectable]=\"selectable\"\n\t\t[ngxTreeGridRowExpanded]=\"openRows.has(rowIndex)\"\n\t\t[attr.aria-selected]=\"\n\t\t\trowsFormGroup.get(selectableKey ? '' + data[rowIndex][selectableKey] : '' + rowIndex)\n\t\t\t\t?.value\n\t\t\"\n\t\t(ngxTreeGridRowSelectRow)=\"selectRow(rowIndex)\"\n\t\t(ngxTreeGridRowExpandRow)=\"handleRowState(rowIndex, $event ? 'open' : 'close')\"\n\t\t(keydown.enter)=\"handleRowClicked(row, rowIndex)\"\n\t></tr>\n\t@if (detailRowTemplate) {\n\t<tr\n\t\t*cdkRowDef=\"let row; let index = dataIndex; columns: ['ngxTableDetailColumn']\"\n\t\tclass=\"ngx-table-detail-row\"\n\t\tcdk-row\n\t\taria-level=\"2\"\n\t\taria-posinset=\"1\"\n\t\t[class.ngx-table-detail-row-open]=\"\n\t\t\tshowDetailRow === 'always' ||\n\t\t\t(showDetailRow === 'on-single-item' && data?.length === 1) ||\n\t\t\topenRows.has(index)\n\t\t\"\n\t></tr>\n\t} @if (hasFooterTemplates()) {\n\t<tr *cdkFooterRowDef=\"definedColumns()\" class=\"ngx-table-footer-row\" cdk-footer-row></tr>\n\t} }\n</table>\n\n@if (!loading && (!data || data.length === 0)) {\n<div>\n\t<ng-template [ngTemplateOutlet]=\"emptyTemplate\"> </ng-template>\n</div>\n} @if (loading) {\n<div>\n\t<ng-template [ngTemplateOutlet]=\"loadingTemplate\"> </ng-template>\n</div>\n}\n\n<ng-template #detailRowTmpl let-row let-index=\"index\">\n\t@if ( showDetailRow === 'always' || (showDetailRow === 'on-single-item' && data?.length === 1)\n\t|| openRows.has(index) ) {\n\t<ng-template\n\t\t[ngTemplateOutlet]=\"detailRowTemplate\"\n\t\t[ngTemplateOutletContext]=\"{ $implicit: row, index }\"\n\t>\n\t</ng-template>\n\t}\n</ng-template>\n\n<ng-template #checkboxTmpl let-control let-row=\"row\" let-index=\"index\">\n\t@if (checkboxTemplate) {\n\t<ng-template\n\t\t[ngTemplateOutlet]=\"checkboxTemplate\"\n\t\t[ngTemplateOutletContext]=\"{ $implicit: control, row: row, index: index }\"\n\t>\n\t</ng-template>\n\t} @else {\n\t<input class=\"ngx-table-checkbox\" type=\"checkbox\" [formControl]=\"control\" />\n\t}\n</ng-template>\n\n<ng-template #radioButtonTmpl let-row=\"row\" let-index=\"index\">\n\t@if (radioTemplate) {\n\t<ng-template\n\t\t[ngTemplateOutlet]=\"radioTemplate\"\n\t\t[ngTemplateOutletContext]=\"{ $implicit: radioControl, row: row, index: index }\"\n\t>\n\t</ng-template>\n\t} @else {\n\t<input\n\t\tclass=\"ngx-table-radio\"\n\t\ttype=\"radio\"\n\t\t[id]=\"index\"\n\t\t[value]=\"selectableKey ? row[selectableKey] : index\"\n\t\tname=\"ngx-table-radio\"\n\t\t[formControl]=\"radioControl\"\n\t/>\n\t}\n</ng-template>\n\n<ng-template #defaultOpenRowStateTmpl let-open>\n\t<i tabindex=\"1\" class=\"ngx-table-open-state-icon\" [innerHtml]=\"open ? '&#9650;' : '&#9660;'\">\n\t</i>\n</ng-template>\n",
      styles: [":host{display:block;width:100%;height:100%}:host .ngx-table{width:100%;height:100%;border-spacing:0px;border-top:1px solid black;border-left:1px solid black}:host .ngx-table.ngx-table-hide-rows .ngx-table-row,:host .ngx-table.ngx-table-hide-rows .ngx-table-footer-row{display:none}:host .ngx-table.ngx-table-clickable-rows .ngx-table-row{cursor:pointer}:host .ngx-table-selectable-cell{width:25px;text-align:center}:host .ngx-table-sortable-cell{cursor:pointer}:host .ngx-table-sortable-cell .ngx-table-sorting-cell-button{width:100%;height:100%;padding:0;font-weight:inherit;background-color:transparent;border:none}:host .ngx-table-sortable-cell .ngx-table-sorting-icon{font-style:normal}:host .ngx-table-open-row-state-cell{width:50px}:host .ngx-table-open-row-state-cell .ngx-table-open-state-icon{font-style:normal}:host .ngx-table-open-row-state-cell .ngx-table-open-state-icon.is-reversed{transform:rotate(180deg)}:host .ngx-table-cell{padding:15px;border-right:1px solid black;border-bottom:1px solid black}:host .ngx-table-detail-row:not(.ngx-table-detail-row-open){display:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NgxTableConfigToken]
    }]
  }], {
    componentClass: [{
      type: HostBinding,
      args: ['class']
    }],
    loading: [{
      type: HostBinding,
      args: ['ngx-table-loading']
    }, {
      type: Input
    }],
    tableCellTemplates: [{
      type: ContentChildren,
      args: [NgxAbstractTableCellDirective]
    }],
    detailRowTemplate: [{
      type: ContentChild,
      args: ['detailRowTmpl', {
        static: false
      }]
    }],
    emptyTemplate: [{
      type: ContentChild,
      args: ['emptyTmpl', {
        static: false
      }]
    }],
    loadingTemplate: [{
      type: ContentChild,
      args: ['loadingTmpl', {
        static: false
      }]
    }],
    checkboxTemplate: [{
      type: ContentChild,
      args: ['checkboxTmpl', {
        static: false
      }]
    }],
    radioTemplate: [{
      type: ContentChild,
      args: ['radioTmpl', {
        static: false
      }]
    }],
    sortTemplate: [{
      type: ContentChild,
      args: ['sortTmpl', {
        static: false
      }]
    }],
    openRowStateTemplate: [{
      type: ContentChild,
      args: ['openRowStateTmpl', {
        static: false
      }]
    }],
    columns: [{
      type: Input
    }],
    actions: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    allowMultipleOpenRows: [{
      type: Input
    }],
    selectable: [{
      type: Input
    }],
    selectableKey: [{
      type: Input
    }],
    selectableType: [{
      type: Input
    }],
    resetFormOnNewData: [{
      type: Input
    }],
    currentSorting: [{
      type: Input
    }],
    showSelectedOpenRow: [{
      type: Input
    }],
    rowClass: [{
      type: Input
    }],
    highlightKey: [{
      type: Input
    }],
    showOpenRowState: [{
      type: Input
    }],
    showDetailRow: [{
      type: Input
    }],
    emitValueOnSingleItem: [{
      type: Input
    }],
    defaultRowOpen: [{
      type: Input
    }],
    hideHeaderWhen: [{
      type: Input
    }],
    rowClicked: [{
      type: Output
    }]
  });
})();

/** All the necessary ngx-table components */
const NgxTable = [NgxTableComponent, ...Cells];

/*
 * Public API Surface of table
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Cells, NgxAbstractTableCellDirective, NgxAriaSortPipe, NgxCurrencyTableCellComponent, NgxDateTableCellComponent, NgxTable, NgxTableCellDirective, NgxTableComponent, NgxTableConfigToken, NgxTableGetPipe, NgxTableHasObserversPipe, NgxTableShowHeaderPipe, NgxTableSortDirection, NgxTableSortIconPipe, Pipes };
